PJQ.collections.schedule = {};

PJQ.models.schedule = {};

PJQ.views.schedule = {};

PJQ.modules.schedule = {
    routes: [
        {
            route: 'schedule/share/:accessKey',
            name: 'scheduleShare',
            callback: function (accessKey) {
                PJQ.app.session.set('accessKey', accessKey);
                let share = new PJQ.models.schedule.ScheduleShare({
                    accessKey: accessKey
                });
                share.fetch({
                    success: function () {
                        let schedule;
                        if (share.get('lookAheadId') > 0) {
                            schedule = new PJQ.models.schedule.LookAhead({
                                projectId: share.get('projectId'),
                                id: share.get('lookAheadId')
                            });
                        } else if (share.get('projectId') > 0) {
                            schedule = new PJQ.models.schedule.Schedule({
                                projectId: share.get('projectId')
                            });
                        }
                        schedule.fetch({
                            success: function () {
                                PJQ.app.view.renderView(PJQ.views.schedule.ScheduleDashboard, {
                                    model: schedule,
                                    shareKey: accessKey
                                });
                            }
                        });
                    }
                });
            }
        },
        {
            route: 'projects/:projectId/schedule',
            name: 'projectSchedule',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectschedule");
            }
        },
        {
            route: 'projects/:projectId/schedule/lookaheads/:lookAheadId',
            name: 'projectSchedule',
            callback: function (projectId, lookAheadId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectschedule", {
                    lookAheadId: parseInt(lookAheadId),
                    noRoute: true
                });
            }
        },
        {
            route: 'projects/:projectId/schedule/:taskId',
            name: 'projectSchedule',
            callback: function (projectId, taskId) {
                PJQ.app.router.navigate('projects/' + projectId.toString() + '/schedule', {
                    trigger: false,
                    replace: true
                });
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectschedule", {
                    taskId: taskId
                });
            }
        },
    ]
};

PJQ.app.addRoutes(PJQ.modules.schedule.routes);
PJQ.views.schedule.ScheduleDashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Schedule-Dashboard'),
        activeView: PJQ.constants.schedule.views.TASK_LIST,
        initTaskId: null,
        isShowCriticalPath: false,
        isAdmin: true
    },
    events: {
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-view-timeline': 'activateTimeline',
        'click .btn-view-task-list': 'activateTaskList',
        'click .btn-view-calendar': 'activateCalendar',
        'click .btn-export-schedule': 'exportSchedule',
        'click .btn-export-view': 'exportView',
        'click .btn-export-gantt': 'exportGantt',
        'click .btn-export-calendar': 'exportCalendar',
        'click .btn-share-schedule': 'shareSchedule',
        'click .btn-order-gantt': 'orderGantt',
        'click .btn-add-task': 'addTaskClicked',
        'click .btn-add-milestone': 'addMilestoneClicked',
        'click .btn-save-as-template': 'saveAsTemplate',
        'click .btn-import-template': 'importTemplate',
        'click .btn-upload-template': 'uploadTemplate',
        'click .btn-schedule-settings': 'editSettings',
        'change .cb-show-critical-path': 'showCriticalPath',
        'click .btn-view-requested-changes': 'viewRequestedChanges',
        'click .btn-zoom-in': 'zoomInGantt',
        'click .btn-zoom-out': 'zoomOutGantt',
        'click .btn-view-master': 'viewMasterSchedule',
        'click .btn-delete-look-ahead': 'deleteLookAhead',
    },
    beforeFirstRender: async function () {
        this.options.canViewLookAheads = false;
        this.options.canManageLookAheads = false;
        this.options.preferences = PJQ.app.session.project ? PJQ.app.session.project.preferences : PJQ.app.session.preferences;
        this.lookAheads = null;

        if(this.model != null){
            this.schedule = this.model;
        }

        if (this.options.project != null) {
            this.options.isAdmin = this.options.project.hasPermission('schedule.isAdmin');
            this.options.canViewLookAheads = this.options.project.hasPermission('schedule.canViewLookAheads');
            this.options.canManageLookAheads = this.options.project.hasPermission('schedule.canManageLookAheads');

            this.settings = await this.options.project.fetchScheduleSettings();
            this.model = this.schedule = await this.options.project.fetchSchedule();

            if (this.options.canViewLookAheads) {
                this.lookAheads = await this.options.project.fetchScheduleLookAheads();
            }
        } else {
            this.options.isAdmin = this.model.get('templateId') > 0 && PJQ.app.session.hasPermission('schedule.isAdmin');
            this.settings = await PJQ.app.session.fetchScheduleSettings();
        }
        this.options.activeView = this.settings.get('defaultView');

        if (this.options.initLookAheadId > 0) {
            if(this.options.shareKey != null) {
                let initLookAhead = new PJQ.models.schedule.LookAhead({
                    id: this.options.initLookAheadId
                });
                if (initLookAhead != null) {
                    this.options.lookAhead = initLookAhead;
                    await this.options.lookAhead.fetch();
                }
                this.options.initLookAheadId = null;
            }
            else if(this.lookAheads != null){
                let initLookAhead = this.lookAheads.get(this.options.initLookAheadId);
                if (initLookAhead != null) {
                    this.options.lookAhead = initLookAhead;
                    await this.options.lookAhead.fetch();
                }
                this.options.initLookAheadId = null;
            }
        }

        this.render();
    },
    beforeRender: function () {
        if (this.options.lookAhead) {
            this.model = this.options.lookAhead;
        } else {
            this.model = this.schedule;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            settings: this.settings,
            project: this.options.project,
            isShowCriticalPath: this.options.isShowCriticalPath,
            activeView: this.options.activeView,
            statuses: this.model ? this.model.statuses : new PJQ.collections.schedule.TaskStatuses(),
            isAdmin: this.options.isAdmin,
            lookAhead: this.options.lookAhead,
            canViewLookAheads: this.options.canViewLookAheads,
            canManageLookAheads: this.options.canManageLookAheads,
            preferences: this.options.preferences
        };
    },
    afterRender: function () {
        this.chart = null;

        if (this.model != null && this.model.isFetched) {
            this.$activeView = this.$('.schedule-dashboard-view');
            switch (this.options.activeView) {
                case PJQ.constants.schedule.views.TASK_LIST:
                    this.renderTaskList();
                    break;
                case PJQ.constants.schedule.views.TIMELINE:
                    this.renderTimeline();
                    break;
                case PJQ.constants.schedule.views.CALENDAR:
                default:
                    this.renderCalendar();
                    break;
            }

            if (this.options.initTaskId > 0) {
                let initTask = this.model.tasks.get(this.options.initTaskId);
                if (initTask != null) {
                    this.editTask(initTask);
                }
                this.options.initTaskId = null;
            }
            this.renderPendingCount();

            if (this.options.canViewLookAheads && this.model.get('projectId') > 0) {
                let lookAheadChoices = [{
                    id: -1,
                    name: "<i class='fal fa-plus mr-1'></i>New Look-Ahead"
                }];
                _.each(this.lookAheads.models, (lookAhead) => {
                    lookAheadChoices.push({
                        id: lookAhead.id,
                        name: '<strong>' + lookAhead.getDisplayName() + '</strong> | ' + (lookAhead.get('duration') / 7) + ' weeks',
                        subtext: 'Actual: ' + lookAhead.getDisplayName(true)
                    });
                })

                this.lookAheadPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-look-ahead'),
                    isIntChoices: true,
                    isMultiple: false,
                    isBlockSubtext: true,
                    defaultValue: this.options.lookAhead ? this.options.lookAhead.id : 0,
                    choices: [
                        {
                            name: "",
                            choices: [{
                                id: 0,
                                name: "Master Schedule"
                            }]
                        },
                        {
                            name: "Look-Aheads",
                            choices: lookAheadChoices
                        }
                    ],
                    onChange: (value) => {
                        if (value === -1) {
                            this.lookAheadPicker.setValue(this.options.lookAhead ? this.options.lookAhead.id : 0);
                            this.newLookAhead();
                        } else {
                            this.options.lookAhead = value > 0 ? this.lookAheads.get(value) : null;
                        }

                        if (this.options.lookAhead != null) {
                            this.options.lookAhead.fetch({
                                success: () => {
                                    this.render();
                                }
                            })
                        } else {
                            this.render();
                        }

                        let route = 'projects/' + this.model.get('projectId').toString() + '/schedule';
                        if (this.options.lookAhead != null) {
                            route += '/lookaheads/' + this.options.lookAhead.id.toString();
                        }
                        PJQ.app.router.navigate(route, {
                            trigger: false,
                            replace: true
                        });
                    }
                });
            }
        }
    },
    newLookAhead: function () {
        new PJQ.views.schedule.NewLookAheadModal({
            projectId: this.options.project.id,
            schedule: this.schedule,
            lookAheads: this.lookAheads,
            onSave: _.bind(function (lookAhead) {
                this.lookAheads.add(lookAhead);
                this.options.lookAhead = lookAhead;
                lookAhead.isFetched = true;
                this.render();
            }, this)
        });
    },
    deleteLookAhead: function () {
        if (this.options.lookAhead == null) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Delete Schedule Look-Ahead?",
            body: "Are you sure you want to delete this look-ahead? This action cannot be undone.",
            onYes: () => {
                this.options.lookAhead.destroy({
                    success: () => {
                        this.lookAheads.remove(this.options.lookAhead);
                        this.options.lookAhead = null;
                        this.render();

                        PJQ.notifications.notify.successNotify({
                            message: 'Look-Ahead deleted successfully'
                        });
                    }
                });
            }
        });
    },
    viewMasterSchedule: function () {
        this.options.lookAhead = null;
        this.render();
    },
    viewNotificationHistory: async function () {
        if (this.options.project == null) {
            return;
        }

        let notifications = await this.options.project.fetchScheduleNotifications(null, true);
        new PJQ.views.notifications.NotificationHistory({
            context: "Project Schedule",
            collection: notifications,
            extraColumns: [
                {
                    "index": 1,
                    "data": "",
                    "title": "Task",
                    // "width": "20%",
                    "render": function (data, type, row) {
                        return row.get('taskName') ?? "";
                    }
                }
            ]
        });
    },
    shareSchedule: function () {
        let sharingModal = new PJQ.views.sharing.SharingModal({
            subject: 'A project schedule has been shared with you',
            project: this.options.project,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function (share) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Schedule share email sent'
                    });
                }, this));
            }, this)
        });
        this.model.share(null, function (share) {
            let callback = _.bind(sharingModal.urlChanged, sharingModal);
            callback(share.get('url'));
        });
    },
    setActiveView: function (newActiveView) {
        if (newActiveView != null) {
            this.options.activeView = newActiveView;
            this.render();
        }
    },
    activateCalendar: function () {
        this.setActiveView(PJQ.constants.schedule.views.CALENDAR);
    },
    renderCalendar: function ($overrideEl, afterChartInit = null) {
        new PJQ.views.calendars.FullCalendar({
            el: _.size($overrideEl) > 0 ? $overrideEl : this.$activeView,
            collection: this.model.tasks.getCalendarTasks(),
            schedule: this.model,
            project: this.options.project,
            onTaskEdit: _.bind(function (task) {
                this.editTask(task);
            }, this),
            canDelete: this.options.isAdmin,
            onTaskDelete: _.bind(function (task) {
                this.deleteTaskClicked(task);
            }, this)
        });
        if (typeof afterChartInit === 'function') {
            afterChartInit();
        }
    },
    activateTimeline: function () {
        this.setActiveView(PJQ.constants.schedule.views.TIMELINE);
    },
    renderTimeline: function (opts = null) {
        if (opts == null) {
            opts = {};
        }

        let hasOverride = _.size(opts.$overrideEl) > 0,
            $chart;
        if (hasOverride) {
            $chart = opts.$overrideEl;
        } else {
            if (this.chart != null) {
                this.chart.refreshTasks(this.model.tasks.getGanttTasks(), opts.contextTask);
                return;
            }

            $chart = this.$activeView;
        }
        let sortColumnCookie = PJQ.constants.cookies.SCHEDULE_GANTT_SORT_COLUMN,
            sortDirectionCookie = PJQ.constants.cookies.SCHEDULE_GANTT_SORT_DIRECTION,
            prefs = PJQ.app.session.project != null ? PJQ.app.session.project.preferences : PJQ.app.session.preferences,
            enableColumnSorting = prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_GANTT_COLUMN_SORTING),
            ch = new PJQ.views.charts.dhtmlxGantt({
                el: $chart,
                shareKey: this.options.shareKey,
                schedule: this.model,
                settings: this.settings,
                canEdit: this.options.isAdmin,
                enableSorting: enableColumnSorting,
                sortField: !enableColumnSorting ? null : PJQ.helpers.cookieHelpers.getCookie(sortColumnCookie),
                sortAsc: !enableColumnSorting ? null : PJQ.helpers.cookieHelpers.getCookie(sortDirectionCookie) === 'asc',
                isShowCriticalPath: this.options.isShowCriticalPath,
                onSort: function (sort) {
                    PJQ.helpers.cookieHelpers.setCookie(sortColumnCookie, sort.field);
                    PJQ.helpers.cookieHelpers.setCookie(sortDirectionCookie, sort.asc ? 'asc' : 'desc');
                },
                onAddSubTask: (parent) => {
                    let fnAdd = () => {
                        let newTask = new PJQ.models.schedule.Task({
                            projectId: this.model ? this.model.get('projectId') : null,
                            templateId: this.model ? this.model.get('templateId') : null,
                            lookAheadId: this.model ? this.model.get('lookAheadId') : null,
                            status: this.model.statuses.getDefault(),
                            summaryTaskId: parent.get('taskId'),
                            start: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            finish: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            sortOrder: _.size(_.filter(this.model.tasks.models, function (model) {
                                if (parent) {
                                    return model.get('summaryTaskId') === parent.get('taskId')
                                } else {
                                    return model.get('summaryTaskId') == null;
                                }
                            }, this)) + 1
                        });
                        newTask.save(null, {
                            success: _.bind(function () {
                                this.model.tasks.add(newTask);
                                this.chart.refreshTasks();
                                this.chart.startInlineEdit(newTask.id);
                            }, this)
                        });
                    }
                    if (!parent.get('isSummaryTask')) {
                        new PJQ.views.modals.YesNo({
                            header: "Convert to Summary Task?",
                            body: "Creating a sub-task will convert this task to a summary task. Are you sure you want to proceed?",
                            onYes: _.bind(function () {
                                parent.set('isSummaryTask', true);
                                fnAdd();
                            }, this)
                        });
                    } else {
                        fnAdd();
                    }
                },
                onTaskAdd: _.bind(function (task, callback) {
                    let parent = task.parent ? this.model.tasks.get(task.parent) : null,
                        newTask = new PJQ.models.schedule.Task({
                            projectId: this.model ? this.model.get('projectId') : null,
                            templateId: this.model ? this.model.get('templateId') : null,
                            status: this.model.statuses.getDefault(),
                            summaryTaskId: parent && parent.get('isSummaryTask') ? parent.get('taskId') : null,
                            parentTaskId: null,
                            start: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            finish: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            sortOrder: _.size(_.filter(this.model.tasks.models, function (model) {
                                if (parent) {
                                    return model.get('summaryTaskId') === parent.get('taskId')
                                } else {
                                    return model.get('summaryTaskId') == null;
                                }
                            }, this)) + 1
                        });
                    newTask.save(null, {
                        success: _.bind(function () {
                            this.model.tasks.add(newTask);
                            this.chart.refreshTasks();
                            if (typeof callback === 'function') {
                                callback(newTask);
                            }
                        }, this)
                    });
                }, this),
                onTaskEdit: _.bind(function (task) {
                    this.editTask(task);
                }, this),
                onTaskDelete: _.bind(function (task) {
                    if (task) {
                        this.deleteTaskClicked(task, false);
                    }
                }, this),
                onTaskMoved: _.bind(function (taskModel, task, editedValue, isTrueDate = false) {
                    // The gantt considers the end_date to be the day after the last working day, e.g., Start Date is August 08, 2022, and the duration is 2 days,
                    // the Gantt considers the end_date as August 10, 2022, whereas our API considers it to be August 09, 2022. So we subtract a day from the end_date
                    let endDate = new Date(task.end_date - 1);
                    endDate.setHours(0, 0, 0, 0);
                    if (task.type === 'milestone' || isTrueDate) {
                        endDate = new Date(task.end_date);
                    }
                    if (task.unscheduled) {
                        // if the task in unscheduled, we need to handle it in different ways
                        if (editedValue === 'text') {
                            taskModel.set({
                                name: task.text,
                                start: null,
                                finish: null,
                                duration: task.duration,
                                percentComplete: Math.round(task.progress * 100)
                            });
                        } else if (editedValue === 'start_date') {
                            taskModel.set({
                                name: task.text,
                                start: task.start_date,
                                finish: task.start_date,
                                duration: 1,
                                percentComplete: Math.round(task.progress * 100)
                            });
                        } else if (editedValue === 'end_date') {
                            taskModel.set({
                                name: task.text,
                                start: task.end_date,
                                finish: task.end_date,
                                duration: 1,
                                percentComplete: Math.round(task.progress * 100)
                            });
                        }
                    } else {
                        taskModel.set({
                            name: task.text,
                            start: task.start_date,
                            finish: endDate,
                            duration: PJQ.helpers.dateHelpers.getDateDaysDiff(endDate, task.start_date, !taskModel.get('weekendWork'), true),
                            percentComplete: Math.round(task.progress * 100)
                        });
                    }
                    this.updateTaskTime(taskModel, taskModel.get('name'), taskModel.get('start'), taskModel.get('finish'), taskModel.get('duration'), taskModel.get('percentComplete'));
                }, this),
                onTaskUpdateSummary: _.bind(function (task, summaryTaskId = null, isNewTask = false) {
                    if (isNewTask) {
                        this.model.tasks.add(task);
                    }
                    if (parseInt(summaryTaskId) !== parseInt(task.get('summaryTaskId'))) {
                        this.updateSummaryTask(task, summaryTaskId);
                    }
                }, this),
                onTaskUpdated: _.bind(function (taskModel, task) {
                    let endDate = new Date(task.end_date);
                    endDate.setHours(0, 0, 0, 0);
                    if (task.type === 'milestone') {
                        endDate = new Date(task.end_date);
                    }
                    taskModel.set({
                        name: task.text,
                        start: task.start_date,
                        finish: endDate,
                        duration: task.duration,
                        percentComplete: Math.round(task.progress * 100)
                    });
                    this.updateTaskTime(taskModel, taskModel.get('name'), taskModel.get('start'), taskModel.get('finish'), taskModel.get('duration'), taskModel.get('percentComplete'));
                }, this),
                onTaskUpdateSummary: _.bind(function (task, summaryTaskId = null, isNewTask = false) {
                    if (isNewTask) {
                        this.model.tasks.add(task);
                    }
                    if (parseInt(summaryTaskId) !== parseInt(task.get('summaryTaskId'))) {
                        this.updateSummaryTask(task, summaryTaskId);
                    }
                }, this),
                onDependencyAdd: _.bind(function (task, dependencyInfo) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'schedule'
                            },
                            {
                                endpoint: 'tasks',
                                value: task.get('taskId')
                            },
                            {
                                endpoint: 'dependencies'
                            }
                        ]),
                        data: {
                            taskId: task.get('taskId'),
                            dependTaskId: parseInt(dependencyInfo.source),
                            offset: dependencyInfo.lag,
                            type: PJQ.constants.schedule.linkTypes[parseInt(dependencyInfo.type)]
                        }
                    }).post().done(_.bind(function (data) {
                        _.each(data.changes, function (task) {
                            let colTask = this.model.tasks.get(task.taskId);
                            task.start = PJQ.helpers.dateHelpers.parseDateString(task.start, false);
                            task.finish = PJQ.helpers.dateHelpers.parseDateString(task.finish, false);
                            colTask.set({
                                start: task.start,
                                finish: task.finish
                            });
                            this.chart.updateTask(colTask);
                        }, this);

                        let task = this.model.tasks.get(data.dependency.taskId);

                        // Fetch the task to get the dependencyId
                        task.fetch({
                            success: _.bind(function (task) {
                                let dependency = _.max(task.dependencies.models, function (dependency) {
                                    return dependency.get('dependencyId');
                                }, this);
                                this.model.dependencies.add(dependency);
                                this.chart.refreshTasks();
                            }, this)
                        })
                    }, this));
                }, this),
                onDependencyDelete: _.bind(function (task, dependencyInfo) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'schedule'
                            },
                            {
                                endpoint: 'tasks',
                                value: task.get('taskId')
                            },
                            {
                                endpoint: 'dependencies',
                                value: dependencyInfo.id
                            }
                        ])
                    }).delete().done(_.bind(function (data) {
                        this.model.dependencies.remove(dependencyInfo.id);
                        task.dependencies.remove(dependencyInfo.id);
                    }, this));
                }, this)
            });

        if (!hasOverride) {
            this.chart = ch;
        }
    },
    zoomInGantt: function () {
        this.chart.zoomIn();
        let zoomLevel = this.chart.getZoom();
        this.$('.btn-zoom-in').attr('disabled', (zoomLevel === 0));
        this.$('.btn-zoom-out').attr('disabled', (zoomLevel === 4));
    },
    zoomOutGantt: function () {
        this.chart.zoomOut();
        let zoomLevel = this.chart.getZoom();
        this.$('.btn-zoom-in').attr('disabled', (zoomLevel === 0));
        this.$('.btn-zoom-out').attr('disabled', (zoomLevel === 4));
    },
    showCriticalPath: function () {
        this.options.isShowCriticalPath = !this.options.isShowCriticalPath;
        this.chart.toggleCriticalPath(this.options.isShowCriticalPath);
    },
    activateTaskList: function () {
        this.setActiveView(PJQ.constants.schedule.views.TASK_LIST);
    },
    renderTaskList: function () {
        this.addLoader();
        this.taskList = new PJQ.views.schedule.TaskList({
            el: this.$activeView,
            project: this.options.project,
            schedule: this.model,
            model: this.model,
            isAdmin: this.options.isAdmin,
            onTaskEdit: _.bind(function (task) {
                this.editTask(task);
            }, this),
            onTaskDelete: _.bind(function (task) {
                this.deleteTaskClicked(task);
            }, this),
            onTaskUpdateSummary: _.bind(function (task, summaryTaskId = null, isNewTask = false) {
                if (isNewTask) {
                    this.model.tasks.add(task);
                }
                if (parseInt(summaryTaskId) !== parseInt(task.get('summaryTaskId'))) {
                    this.updateSummaryTask(task, summaryTaskId);
                }
            }, this),
            afterTableRendered: _.bind(function () {
                this.removeLoader();
            }, this)
        });
    },
    updateTaskTime: function (task, name, start, finish, duration, percentComplete) {
        this.addLoader();
        if (task.model) {
            task.model.set({
                name: name,
                duration: duration,
                percentComplete: percentComplete
            });
        }

        let fnSave = () => {
            new PJQ.ajax.Request({
                data: {
                    name: name,
                    start: start,
                    finish: finish,
                    duration: duration,
                    percentComplete: percentComplete
                },
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'schedule'
                    },
                    {
                        endpoint: 'tasks',
                        value: task.model ? task.model.get('taskId') : task.get('taskId')
                    }
                ])
            }).patch().done(_.bind(function (res) {
                this.removeLoader();
                let updatedTask = task.model ? task.model : task;
                if (_.size(res.changes) > 0) {
                    _.each(res.changes, function (change) {
                        let changedTask = this.model.tasks.get(change.taskId);
                        if (changedTask != null) {
                            changedTask.set({
                                start: PJQ.helpers.dateHelpers.parseDateString(change.start, false),
                                finish: PJQ.helpers.dateHelpers.parseDateString(change.finish, false)
                            });

                            if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST) {
                                PJQ.app.session.project.trigger('scheduleTaskChanged', changedTask, false);
                            }

                            if (this.chart && typeof this.chart.updateTask === 'function') {
                                this.chart.updateTask(changedTask);
                            }
                        }
                    }, this);
                }
                if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE) {
                    this.chart.updateTask(task);
                }
            }, this));
        };
        if ((task.model ? task.model : task).get('projectId') > 0 && this.settings.get('notificationsEnabled') && this.settings.get('dateChangeNotificationsMode') === 1) {
            let changedTasks = (task.model ? task.model : task).determineChangedTasks();
            new PJQ.views.schedule.TaskChangeNotifications({
                changedTasks: changedTasks,
                onSave: _.bind(function (res) {
                    fnSave(res.noNotify);
                }, this)
            });
        } else {
            fnSave();
        }
    },
    addLoader: function () {
        this.loader = new PJQ.Loader(this.$('.schedule-dashboard-view'));
    },
    removeLoader: function () {
        this.loader.remove();
    },
    editTask: function (task) {
        let taskModel = task,
            isNew = task.id == null;
        if (this.chart && task == null) {
            taskModel = _.find(this.chart.collection.models, function (model) {
                return model.get('id') === task.get('taskId');
            })
        }
        let fnModal = _.bind(function () {
            new PJQ.views.schedule.EditTaskModal({
                project: this.options.project,
                isSummaryTask: task.get('isSummaryTask'),
                schedule: this.model,
                model: task,
                onSave: _.bind(function () {
                    // Need to fetch the task to get any new dependencies ids, otherwise you cannot delete the dependency if you edit it again without refreshing.
                    task.fetch({
                        success: _.bind(function (taskModel) {
                            _.each(this.model.dependencies.models, function (dep) {
                                if (dep && dep.id < 0) {
                                    this.model.dependencies.remove(dep);
                                }
                                let updatedDep = taskModel.dependencies.get(dep.id);
                                if (updatedDep != null) {
                                    dep.set('offset', updatedDep.get('offset'));
                                    dep.set('type', updatedDep.get('type'));
                                }
                            }, this)
                            this.model.dependencies.add(taskModel.dependencies.models);

                            if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE) {
                                if (_.size(this.model.tasks.models) === 1) {
                                    this.render()
                                } else {
                                    this.renderTimeline();
                                }
                            } else if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST) {
                                if (_.size(this.model.tasks.models) === 1) {
                                    this.render()
                                } else {
                                    PJQ.app.session.project.trigger('scheduleTaskChanged', taskModel, isNew);
                                }
                            } else {
                                this.render();
                            }
                        }, this)
                    })
                }, this),
                onClose: _.bind(function () {
                    if (task.isNew()) {
                        this.model.tasks.remove(task);
                        if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE && _.size(this.model.tasks) > 0) {
                            this.renderTimeline();
                        } else {
                            this.render();
                        }
                    } else {
                        this.renderPendingCount();
                    }
                }, this),
                onDelete: _.bind(function () {
                    this.deleteTask(task);
                }, this)
            });
        }, this);
        if (!task.isNew()) {
            task.fetch({
                success: _.bind(function () {
                    fnModal();
                }, this)
            })
        } else {
            fnModal();
        }
    },
    deleteTaskClicked: function (task, showConfirmation = true) {
        let summaryTask = _.find(this.model.tasks.models, function (model) {
                return model.get('taskId') === task.get('summaryTaskId')
            }, this),
            isLastRemainingTask = false;
        if (summaryTask != null) {
            isLastRemainingTask = true;
            _.each(this.model.tasks.models, function (model) {
                if (model.get('summaryTaskId') === summaryTask.get('taskId') && model.get('taskId') !== task.get('taskId')) {
                    isLastRemainingTask = false;
                }
            }, this)
        }
        if (isLastRemainingTask && showConfirmation) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "This is the last remaining task in the summary task \"" + summaryTask.get('name') + "\". Deleting this task will also delete the summary task. Are you sure you want to delete this task?",
                onDelete: _.bind(function () {
                    this.deleteTask(task, summaryTask);
                }, this)
            });
        } else if (showConfirmation) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this task?",
                onDelete: _.bind(function () {
                    this.deleteTask(task);
                }, this)
            });
        } else {
            this.deleteTask(task);
        }
    },
    deleteTask: function (originalTask, summary) {
        let nestedTasks = [originalTask],
            deletedDependencies = [],
            getNestedTasks = _.bind(function (task) {
                // First get the nested tasks for the passed through task
                let taskNestedTasks = _.filter(this.model.tasks.models, function (model) {
                    return model.get('parentTaskId') === task.get('taskId') || model.get('summaryTaskId') === task.get('taskId')
                }, this);
                // Concat this tasks nested tasks with the existing nested tasks array
                nestedTasks = nestedTasks.concat(taskNestedTasks);
                //Check if any of the child tasks have children
                _.each(taskNestedTasks, function (nestedTask) {
                    let hasChild = _.find(this.model.tasks.models, function (model) {
                        return model.get('summaryTaskId') === nestedTask.get('taskId') || model.get('parentTaskId') === nestedTask.get('taskId');
                    }, this)
                    // if a child task exists, then run the function again to get those child tasks
                    if (hasChild) {
                        getNestedTasks(nestedTask);
                    }
                }, this);
            }, this);
        // Get the nested tasks that need to be deleted from the original task
        getNestedTasks(originalTask);
        // Find the dependencies that include any of the tasks that will be deleted
        _.each(this.model.dependencies.models, function (dependency) {
            let deletedTask = _.find(nestedTasks, function (task) {
                return task.get('taskId') === dependency.get('taskId') || task.get('taskId') === dependency.get('dependTaskId');
            })
            if (deletedTask) {
                deletedDependencies.push(dependency);
            }
        }, this);
        this.model.tasks.remove(nestedTasks);
        this.model.dependencies.remove(deletedDependencies);
        if (summary) {
            this.model.tasks.remove(summary)
            summary.destroy();
        }
        originalTask.destroy();
        if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE && _.size(this.model.tasks.models) > 0) {
            this.chart.refreshTasks();
        } else if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST && _.size(this.model.tasks.models) > 0) {
            PJQ.app.session.project.trigger('scheduleTaskChanged', originalTask, false, false, true);
        } else {
            this.render()
        }
    },
    updateSummaryTask: function (task, summaryTaskId = null) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks',
                    value: task.model ? task.model.get('taskId') : task.get('taskId')
                },
                {
                    endpoint: 'summary',
                    value: summaryTaskId
                }
            ])
        }).put().done(_.bind(function () {
            if (task.model) {
                task = task.model;
            }
            if (summaryTaskId > 0) {
                let summaryTask = this.model.tasks.get(summaryTaskId),
                    existingSummaryTask = task.get('summaryTaskId') ? this.model.tasks.get(task.get('summaryTaskId')) : null
                summaryTask.set('isSummaryTask', true);
                task.set('summaryTaskId', parseInt(summaryTaskId));
                _.each(summaryTask.dependencies.models, function (dep) {
                    let id = dep.get('dependencyId');
                    _.each(this.model.tasks.models, function (model) {
                        if (model.dependencies.get(id)) {
                            model.dependencies.remove(id)
                        }
                    }, this)
                }, this)

                let name = task.get('name'),
                    start = new Date(task.get('start')),
                    finish = new Date(task.get('finish')),
                    duration = task.get('duration'),
                    percentComplete = task.get('percentComplete');
                this.updateTaskTime(task, name, start, finish, duration, percentComplete);

                // if the summary task is being changed from an existing one, check if there are any other existing tasks on that summary task.
                // if not, it will no longer be a summary task and needs to reflect that.
                if (existingSummaryTask) {
                    let existingSummaryTaskHasChildren = _.find(this.model.tasks.models, function (task) {
                        return task.get('summaryTaskId') === existingSummaryTask.get('taskId')
                    }, this) != null;
                    if (!existingSummaryTaskHasChildren) {
                        existingSummaryTask.set({
                            isSummaryTask: false,
                        });

                        let existingSummaryName = existingSummaryTask.get('name'),
                            existingSummaryStart = new Date(existingSummaryTask.get('start')),
                            existingSummaryFinish = new Date(existingSummaryTask.get('finish')),
                            existingSummaryDuration = existingSummaryTask.get('duration'),
                            existingSummaryPercentComplete = existingSummaryTask.get('percentComplete');
                        this.updateTaskTime(existingSummaryTask, existingSummaryName, existingSummaryStart, existingSummaryFinish, existingSummaryDuration, existingSummaryPercentComplete);
                    }
                }
            } else {
                let summaryTask = _.find(this.model.tasks.models, function (model) {
                    return model.get('taskId') === task.get('summaryTaskId') && model.get('taskId') !== task.get('taskId');
                },)
                let name = summaryTask.get('name'),
                    start = new Date(summaryTask.get('start')),
                    finish = new Date(summaryTask.get('finish')),
                    duration = summaryTask.get('duration'),
                    percentComplete = summaryTask.get('percentComplete');
                this.updateTaskTime(summaryTask, name, start, finish, duration, percentComplete);
                task.set('summaryTaskId', null);

                // If the summary task the task is being removed from has no more tasks underneath it, it will no longer be a summary task.
                summaryTask.set('isSummaryTask', _.find(this.model.tasks.models, function (task) {
                    return task.get('summaryTaskId') === summaryTask.get('taskId')
                }, this) != null);
            }
            if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST) {
                PJQ.app.session.project.trigger('scheduleTaskChanged', task, false, true);
            } else {
                this.render();
            }
        }, this))
    },
    addTaskClicked: function (task) {
        let parentIsSummary = false;
        if (task && parseInt(task.parent) > 0) {
            let parent = this.model.tasks.get(task.parent);
            parentIsSummary = parent.get('isSummaryTask');
        }
        let newTask = new PJQ.models.schedule.Task({
            projectId: this.model ? this.model.get('projectId') : null,
            templateId: this.model ? this.model.get('templateId') : null,
            lookAheadId: this.options.lookAhead != null ? this.options.lookAhead.id : null,
            parentTaskId: parseInt(task.parent) > 0 && !parentIsSummary ? parseInt(task.parent) : null,
            summaryTaskId: parseInt(task.parent) > 0 && parentIsSummary ? parseInt(task.parent) : null,
            sortOrder: _.size(_.filter(this.model.tasks.models, function (model) {
                return model.get('summaryTaskId') == null;
            }, this)) + 1
        });
        this.model.tasks.add(newTask);
        this.editTask(newTask);
    },
    addMilestoneClicked: function () {
        let newTask = new PJQ.models.schedule.Task({
            name: "",
            duration: 1,
            start: null,
            finish: null,
            weekendWork: false,
            isAllDay: true,
            isMilestone: true,
            percentComplete: 0,
            notes: "",
            status: this.model.statuses.getDefault(),
            projectId: this.model ? this.model.get('projectId') : null,
            templateId: this.model ? this.model.get('templateId') : null
        });
        this.model.tasks.add(newTask);
        this.editTask(newTask);
    },
    editSettings: function () {
        new PJQ.views.schedule.SettingsModal({
            model: this.settings,
            project: this.options.project,
            onSave: _.bind(function () {
                this.setActiveView(this.settings.get('defaultView'));
                this.render();
            }, this)
        });
    },
    saveAsTemplate: function () {
        new PJQ.views.schedule.SaveAsTemplateModal({
            project: this.options.project
        });
    },
    importTemplate: function () {
        new PJQ.views.schedule.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (schedule) {
                this.schedule = schedule;
                this.options.project.schedule = this.model;
                this.render();
            }, this)
        });
    },
    uploadTemplate: function () {
        new PJQ.views.schedule.UploadTemplateModal({
            project: this.options.project,
            onImport: _.bind(function () {
                this.model.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    exportSchedule: function () {
        let projectId = null,
            endpoint = null;
        if (this.options.project == null) {
            projectId = this.model.get('projectId');
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: projectId
                },
                {
                    endpoint: 'schedule',
                    value: 'export'
                }
            ], [
                {
                    parameter: 'shareKey',
                    value: this.options.shareKey
                }
            ]);
        }

        new PJQ.ajax.Request({
            endpoint: this.options.project ? this.options.project.endpoint(false) + '/schedule/export' + (this.options.lookAhead != null ? ('?lookAheadId=' + this.options.lookAhead.id) : '') : endpoint,
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    orderGantt: function () {
        this.getGanttData(_.bind(function (data) {
            new PJQ.views.schedule.OrderGanttModal({
                reportData: {
                    data: data,
                    templateName: 'schedule-gantt',
                    fileName: this.options.project.get('projectName').replace(' ', '_') + '_Gantt'
                },
                project: this.options.project
            });
        }, this));
    },
    exportView: function () {
        switch (this.options.activeView) {
            case PJQ.constants.schedule.views.CALENDAR:
                this.exportCalendar();
                return;
            case PJQ.constants.schedule.views.TASK_LIST:
                this.exportSchedule();
                return;
            case PJQ.constants.schedule.views.TIMELINE:
                this.exportGantt();
                return;
        }
    },
    exportCalendar: function () {
        let loader = new PJQ.Loader(this.$('.btn-export'), {
                type: 'button',
                loadingText: 'Exporting'
            }),
            rect = this.$('.fc-day-grid')[0].getBoundingClientRect(),
            $report = this.$activeView.clone();
        PJQ.helpers.elementHelpers.addInvisibleElement($report);
        $report.find('.fc-day-grid-container').height('inherit');

        let params = [];
        if(!this.options.project && this.options.shareKey){
            params.push({
                parameter: 'shareKey',
                value: this.options.shareKey
            })
        }

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'export',
                value: 'calendar'
            }
        ], params);

        PJQ.files.queueDownload(endpoint, {
            data: {
                    html: $report.html(),
                    height: rect.height,
                    width: rect.width,
                    project: this.options.project ? this.options.project.attributes : null,
                    logoURL: PJQ.app.session.project?.preferences.hasPref(PJQ.constants.preferenceTypes.EMAIL_LOGO_URL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.EMAIL_LOGO_URL) : ''
                },
            templateName: 'schedule-calendar',
            filename: (this.options.project ? this.options.project.get('projectName').replace(' ', '_') : 'Project') + '_Calendar'
        }, function(){
            $report.remove();
            loader.remove();
        }, true);
    },
    exportGantt: function (e) {
        let loader = new PJQ.Loader(this.$('.btn-export'), {
                type: 'button',
                loadingText: 'Exporting'
            }),
            $temp = $('<div class="invisible wd-100" />'),
            target = $(e.currentTarget),
            type = target.data('export'),
            fnCallback = _.bind(function () {
                loader.remove();
            }, this);

        $('body').append($temp);
        switch (type) {
            case "png":
                this.chart.exportToPNG(fnCallback);
                break;
            case "pdf":
                this.chart.exportToPDF(fnCallback);
                break;
            case "excel":
                this.chart.exportToExcel(fnCallback);
                break;
            case "msproject":
                this.chart.exportToMSProject(fnCallback);
                break;
            case "primavera":
                this.chart.exportToPrimavera(fnCallback);
                break;
        }
    },
    viewRequestedChanges: function () {
        this.model.fetch({
            success: _.bind(function () {
                new PJQ.views.schedule.ViewRequestedChangesModal({
                    model: this.model,
                    onTaskEdit: _.bind(function (task) {
                        this.editTask(task);
                    }, this),
                    onClose: _.bind(function () {
                        this.renderPendingCount();
                    }, this),
                    onApprove: _.bind(function () {
                        this.render();
                    }, this)
                })
            }, this)
        });
    },
    renderPendingCount: function () {
        if (this.options.project != null && this.options.lookAhead == null) {
            let pendingCount = _.size(_.filter(this.model.pendingRequestedChanges.models, function (change) {
                return change.get('approvedOn') == null && change.get('rejectedOn') == null;
            }));
            let btn = '<button type="button" class="btn btn-light btn-view-requested-changes ht-40p" ' + (pendingCount === 0 ? 'disabled' : '') + ' >Change Requests<span class="badge ' + (pendingCount === 0 ? 'badge-secondary' : 'badge-danger') + ' fs-14 lh-15 ml-1 req-change-count">' + pendingCount.toString() + '</span></button>',
                $btn = this.$('.btn-view-requested-changes');
            $btn.replaceWith(btn);
        }
    }
});

PJQ.views.schedule.ViewRequestedChangesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-View-Requested-Changes'),
        subTemplates: {
            requestedChanges: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-Requested-Changes')
        },
        maxWidth: 800,
        width: '90%',
        onSave: null,
        onTaskEdit: null,
        onApprove: null
    },
    events: {
        'click .btn-delete-requested-change': 'deleteRequestedChange',
        'click .btn-approve-requested-change': 'approveRequestedChangeClicked',
        'click .btn-reject-requested-change': 'rejectRequestedChange',
        'click .btn-request-task': 'viewTask',
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        this.model.pendingRequestedChanges.models = _.filter(this.model.pendingRequestedChanges.models, function (model) {
            return model.get('approvedOn') === null && model.get('rejectedOn') === null;
        });
        this.renderRequestedChanges();
    },
    renderRequestedChanges: function () {
        this.renderSubTemplate(false, this.options.subTemplates.requestedChanges, this.$('.requested-changes-outer'), {
            model: this.model,
            requestedChanges: this.model.pendingRequestedChanges,
            canEdit: true,
            isPendingList: true
        });
    },
    deleteRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.pendingRequestedChanges.get(cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this requested change?",
            onDelete: _.bind(function () {
                requestedChange.set('isDeleted', true);
                this.model.isDirty = true;
                this.renderRequestedChanges();
            }, this)
        });
    },
    approveRequestedChangeClicked: function (e) {
        ;
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.pendingRequestedChanges.get(cid),
            newStart = new Date(requestedChange.get('newStart')),
            newFinish = new Date(requestedChange.get('newFinish')),
            task = _.find(this.model.tasks.models, function (task) {
                return task.get('taskId') === requestedChange.get('taskId');
            })
        if ((newFinish.getDay() === (0 || 6) || newStart.getDay() === (0 || 6)) && !task.get('weekendWork')) {
            new PJQ.views.modals.YesNo({
                header: 'Weekend Work',
                body: 'The new start or finish falls on the weekend. Would you like to turn weekend work on?',
                onYes: _.bind(function () {
                    task.updateWeekendWork(true)
                    this.approveRequestedChange(requestedChange);
                }, this),
                onNo: _.bind(function () {
                    this.approveRequestedChange(requestedChange);
                }, this)
            })
        } else {
            this.approveRequestedChange(requestedChange);
        }
    },
    approveRequestedChange: function (change) {
        let requestedChange = change;
        requestedChange.approve(_.bind(function (res) {
            this.model.set({
                start: new Date(res.requestedChange.newStart),
                finish: new Date(res.requestedChange.newFinish)
            });
            if (_.size(res.changes) > 0) {
                _.each(res.changes, function (change) {
                    let changedTask = this.model.tasks.get(change.taskId);
                    if (changedTask != null) {
                        changedTask.set({
                            start: PJQ.helpers.dateHelpers.parseDateString(change.start, false),
                            finish: PJQ.helpers.dateHelpers.parseDateString(change.finish, false)
                        });
                    }
                }, this);
            }
            this.renderRequestedChanges();

            if (typeof this.options.onApprove === 'function') {
                this.options.onApprove();
            }
        }, this));
    },
    rejectRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.pendingRequestedChanges.get(cid);
        requestedChange.reject(_.bind(function (res) {
            this.renderRequestedChanges();
        }, this));
    },
    viewTask: function (e) {
        let target = $(e.currentTarget),
            taskId = target.data('taskId'),
            task = this.model.tasks.get(taskId);
        this.editTask(task);
    },
    editTask: function (task) {
        if (typeof this.options.onTaskEdit === 'function') {
            this.options.onTaskEdit(task);
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
    }
});

PJQ.views.schedule.OrderGanttModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Order-Gantt'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-order': 'order'
    },
    renderData: function () {
        let email = '',
            phone = '';
        if (PJQ.app.session.user != null) {
            email = PJQ.app.session.user.get('email');
            phone = PJQ.app.session.user.get('phone');
        } else if (PJQ.app.session.contact != null) {
            phone = PJQ.app.session.contact.get('phone');
        }
        return {
            email: email,
            phone: phone
        };
    },
    afterRender: function () {
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));
    },
    order: function () {
        let isValid = true,
            $email = this.$('.input-email'),
            email = $email.val();
        if (!PJQ.helpers.validators.validateEmail(email).success) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError($email, false);
        } else {
            PJQ.helpers.inputHelpers.setInputError($email, true);
        }

        let $phone = this.$('.input-phone'),
            phone = PJQ.helpers.formatHelpers.numbersOnly($phone.val());
        if (_.size(phone) < 10) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError($phone, false);

        } else {
            PJQ.helpers.inputHelpers.setInputError($phone, true);
        }

        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'ordergantt'
                }
            ], [
                {
                    parameter: 'email',
                    value: email
                },
                {
                    parameter: 'phone',
                    value: phone
                }
            ]),
            data: this.options.reportData
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Print order placed successfully'
            });
            this.removeModal();
        }, this));
    }
});

PJQ.views.schedule.EditTaskModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Edit-Task'),
        subTemplates: {
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts'),
            comments: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Comments'),
            dependencies: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-Dependencies'),
            requestedChanges: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-Requested-Changes')
        },
        width: '90%',
        maxWidth: 800,
        statuses: null,
        isShowCloseButton: true,
        onSave: null,
        onClose: null,
        canAddAttachment: true,
        canDeleteAttachment: true,
        canAddComment: true,
        canAddChangeRequest: true,
        canManageChangeRequest: true,
        canEdit: true,
        isAdmin: true,
        isSummaryTask: false,
        start: null,
        finish: null
    },
    events: {
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .btn-delete': 'delete',
        'click .btn-add-comment': 'addComment',
        'change .progress-slider': 'completionChanged',
        'change .cb-completed-notification': 'disableCompletedNotificationChanged',
        'click .btn-add-dependency': 'addDependency',
        'click .btn-add-successor': 'addSuccessor',
        'click .btn-save-dependency': 'saveDependency',
        'click .btn-cancel-dependency': 'cancelDependency',
        'click .btn-edit-dependency': 'editDependency',
        'click .btn-delete-dependency': 'deleteDependency',
        'click .btn-add-requested-change': 'addRequestedChange',
        'click .btn-delete-requested-change': 'deleteRequestedChange',
        'click .btn-approve-requested-change': 'approveRequestedChangeClicked',
        'click .btn-reject-requested-change': 'rejectRequestedChange',
        'click .btn-view-task': 'viewTask',
        'focusout .input-duration': 'checkDuration'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.options.statuses == null && this.options.schedule != null) {
            this.options.statuses = this.options.schedule.statuses;
        } else {
            this.options.statuses = await PJQ.app.session.fetchScheduleStatuses();
        }

        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;

        if (this.options.project != null) {
            this.options.canAddComment = this.options.project.hasPermission('schedule.canAddComment');
            this.options.canAddAttachment = this.options.project.hasPermission('schedule.canAddAttachment');
            this.options.canDeleteAttachment = this.options.project.hasPermission('schedule.canDeleteAttachment');
            this.options.canAddChangeRequest = this.options.project.hasPermission('schedule.canAddChangeRequest');
            this.options.canManageChangeRequest = this.options.project.hasPermission('schedule.canManageChangeRequest');
            this.options.canEdit = this.options.project.hasPermission('schedule.isAdmin');
            this.options.isAdmin = this.options.project.hasPermission('schedule.isAdmin');
        } else if (this.model.get('templateId') != null && !(this.model.get('templateId') > 0)) {
            this.options.canAddComment = false;
            this.options.canAddAttachment = false;
            this.options.canDeleteAttachment = false;
            this.options.canAddChangeRequest = false;
            this.options.canManageChangeRequest = false;
            this.options.canEdit = false;
            this.options.isAdmin = false;
        } else if (this.model.get('projectId') > 0) {
            // if there is no project passed in, but this task is for a project
            //  then it is a share and all permissions are false
            this.options.canAddComment = false;
            this.options.canAddAttachment = false;
            this.options.canDeleteAttachment = false;
            this.options.canAddChangeRequest = false;
            this.options.canManageChangeRequest = false;
            this.options.canEdit = false;
            this.options.isAdmin = false;
        } else if (this.options.project == null) {
            this.options.canAddComment = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canAddAttachment = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canDeleteAttachment = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canAddChangeRequest = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canManageChangeRequest = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.canEdit = PJQ.app.session.hasPermission('calendar.isAdmin');
            this.options.isAdmin = PJQ.app.session.hasPermission('calendar.isAdmin');
        }

        this.listenTo(this.model, 'change:weekendWork', _.bind(function () {
            let start = this.model.get('start');
            if (start != null && this.model.get('duration') > 0) {
                let start = PJQ.helpers.dateHelpers.getNewDateAddDays(this.model.get('start'), 1, !this.model.get('weekendWork'), true),
                    finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, this.model.get('duration'), !this.model.get('weekendWork'), true);
                this.model.set('finish', finish);
                this.startPicker.setValue(start);
                this.finishPicker.setValue(finish);
            }
        }, this));

        this.listenTo(this.model, 'change:start', _.bind(function () {
            let start = this.model.get('start'),
                finish = this.model.get('finish'),
                duration = this.model.get('duration'),
                weekendWork = this.model.get('weekendWork');

            if (this.model.get('isMilestone')) {
                this.model.set('finish', start);
            } else {
                if (start != null) {
                    start = PJQ.helpers.dateHelpers.getNewDateAddDays(start, 1, !weekendWork, true);
                    if (finish == null) {
                        finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, duration === 0 ? 1 : duration, !weekendWork, true);
                        duration = PJQ.helpers.dateHelpers.getDateDaysDiff(finish, start, !weekendWork, true);
                    } else {
                        duration = PJQ.helpers.dateHelpers.getDateDaysDiff(finish, start, !weekendWork, true);
                        if (duration < 1) {
                            duration = 1;
                            finish = start;
                        }
                    }
                } else {
                    // Don't allow unscheduled tasks on tasks that belong to a summary task
                    if (this.model.get('summaryTaskId') != null) {
                        start = finish;
                        duration = 1;
                    }
                    // If task doesn't belong to summary task, then set it as unscheduled
                    else {
                        finish = null;
                        duration = 0;
                    }
                }
                if (this.finishPicker) {
                    this.finishPicker.setValue(finish);
                }
                if (this.startPicker) {
                    this.startPicker.setValue(start);
                }
                this.$('.input-duration').val(duration);
                this.model.set({
                    start: start,
                    finish: finish,
                    duration: duration
                }, {
                    silent: true
                });
            }
        }, this));

        this.listenTo(this.model, 'change:finish', _.bind(function () {
            let start = this.model.get('start'),
                finish = this.model.get('finish'),
                duration = this.model.get('duration'),
                weekendWork = this.model.get('weekendWork');
            if (finish != null) {
                if (start == null) {
                    finish = PJQ.helpers.dateHelpers.getNewDateAddDays(finish, 1, !weekendWork, true);
                    start = finish;
                    duration = 1;
                } else {
                    duration = PJQ.helpers.dateHelpers.getDateDaysDiff(finish, start, !weekendWork, true);
                    finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, duration, !weekendWork, true);
                    if (duration < 1) {
                        duration = 1;
                        start = finish;
                    }
                }
            } else {
                // Don't allow unscheduled tasks on tasks that belong to a summary task
                if (this.model.get('summaryTaskId') != null) {
                    finish = start;
                    duration = 1;
                }
                // If task doesn't belong to summary task, then set it as unscheduled
                else {
                    start = finish;
                    duration = 0;
                }
            }
            if (this.startPicker) {
                this.startPicker.setValue(start);
            }
            if (this.finishPicker) {
                this.finishPicker.setValue(finish);
            }
            this.$('.input-duration').val(duration);
            this.model.set({
                start: start,
                finish: finish,
                duration: duration
            }, {
                silent: true
            });
        }, this));

        this.listenTo(this.model, 'change:duration', _.bind(function () {
            if (!this.model.get('isMilestone')) {
                let start = this.model.get('start');
                if (start == null) {
                    return;
                }
                let newFinish = start;
                let duration = this.model.get('duration');
                if (duration == null) {
                    this.model.set('duration', null);
                    this.model.set('finish', newFinish, {
                        silent: true
                    });
                } else {
                    // Don't allow unscheduled tasks on tasks that belong to a summary task
                    if (duration === 0 && this.model.get('summaryTaskId')) {
                        this.model.set('duration', null);
                        this.model.set('finish', newFinish, {
                            silent: true
                        });
                        return;
                    }
                    newFinish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, duration, !this.model.get('weekendWork'), true);
                    this.model.set('finish', newFinish, {
                        silent: true,
                        duration: duration
                    });
                }

                this.finishPicker.setValue(newFinish);
            }
        }, this));

        if (this.options.settings == null) {
            if (this.options.project != null) {
                this.settings = await this.options.project.fetchScheduleSettings();
            } else {
                this.settings = await PJQ.app.session.fetchScheduleSettings();
            }
        }

        this.options.isSuccessor = false;
        if ((PJQ.app.session.project && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)) ||
            (PJQ.app.session.project == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED))) {
            _.each(this.model.dependencies.models, function (model) {
                if (model.get('taskId') === this.model.get('taskId')) {
                    this.options.isSuccessor = true;
                }
            }, this);
        }

        this.hasCompleteStatus = false;
        _.each(this.options.statuses.models, function (model) {
            if (model.get('name').toLowerCase().includes('complete')) {
                this.hasCompleteStatus = true;
            }
        }, this)

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (this.model.status == null) {
            this.model.status = this.options.statuses.getDefault();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            settings: this.settings,
            statuses: this.options.statuses,
            schedule: this.options.schedule,
            canAddComment: this.options.canAddComment,
            canAddChangeRequest: this.options.canAddChangeRequest,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            isSummaryTask: this.options.isSummaryTask,
            isSuccessor: this.options.isSuccessor,
            preferences: this.preferences,
            enableNotificationSettings: this.preferences ? this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCHEDULE_TASK_NOTIFICATION_SETTINGS) : false,
            isOverdue: this.model.get('percentComplete') < 100 && this.model.get('finish') != null && this.model.id != null && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(this.model.get('finish')) && (this.settings && this.settings.get('enableOverdueStatus')) && this.model.status.get('name').toLowerCase() !== 'complete' && this.hasCompleteStatus
        };
    },
    renderDatePickers: function () {
        if (this.options.start) {
            this.model.set('start', this.options.start);
        }
        if (this.options.finish) {
            this.model.set('finish', this.options.finish);
        }

        this.startPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-start-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('start')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('start', newDate);
            }, this)
        });

        if (!this.model.get('isMilestone')) {
            this.finishPicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-finish-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('finish')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('finish', newDate);
                }, this)
            });
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.settings != null && this.settings.isFetched) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });

            this.renderDatePickers();

            let groupUserId = null,
                groupLevels = null;
            if (this.options.project != null) {
                groupUserId = this.options.project.get('masterUserId');
                groupLevels = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
            }
            new PJQ.views.groups.GroupsSelectInput({
                el: this.$('.schedule-task-groups'),
                isShowAddButton: false,
                groupLevels: groupLevels,
                groupUserId: groupUserId,
                isReadOnly: !this.options.canEdit,
                addButton: this.$('.btn-edit-groups'),
                selectedGroups: this.model.groups.models,
                onAfterSave: _.bind(function (selectedGroups) {
                    this.model.groups.reset(selectedGroups);
                    this.model.isDirty = true;
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.select-status'),
                defaultValue: this.model.status.id,
                onChange: _.bind(function (value) {
                    this.model.status = this.options.statuses.get(value);
                    this.model.isDirty = true;
                }, this)
            });

            if (this.options.canEdit) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('input.task-category'),
                    source: this.model.collection == null ? [] : _.uniq(_.map(_.filter(this.model.collection.models, _.bind(function (task) {
                        return _.size(task.get('category')) > 0 && task.id !== this.model.id;
                    }, this)), function (task) {
                        return task.get('category');
                    }))
                });
            }

            if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                new PJQ.inputs.ProjectLocationPicker({
                    el: this.$('.select-location'),
                    project: this.options.project,
                    canEdit: this.options.canEdit,
                    onChange: _.bind(function (value) {
                        this.model.set('locationId', value);
                    }, this),
                    defaultValue: this.model.get('locationId')
                });
            }

            if (this.options.schedule != null) {
                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.task-assigned'),
                    selectedContact: this.model.assignees.models,
                    isReadOnly: !this.options.canEdit,
                    displayContactsBlock: true,
                    context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                    isSingleChoice: false,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.assignees.reset(selectedContacts);
                        this.model.isDirty = true;
                    }, this)
                });

                this.renderDependencies();
            }

            this.renderCompletion();

            if (!this.model.isNew()) {
                if (this.options.project != null && this.options.schedule != null) {
                    this.renderRequestedChanges();
                }
                this.renderComments();
            }

            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.task-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canAddAttachment,
                canDelete: this.options.canDeleteAttachment,
                previewImageDimension: 150,
                includeProjectAttachments: true,
                onSuccess: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        this.$('.task-name').focus();
        this.$('.input-duration').attr('disabled', this.settings.get('lockSchedule') || !this.options.canEdit || this.model.get('isSummaryTask'));
    },
    checkDuration: function () {
        let duration = this.model.get('duration');
        if (duration == null || duration === 0) {
            duration = 1;
            this.$('.input-duration').val(duration);
            this.model.set('duration', duration);
        }
        // else if (duration === 0) {
        //     this.model.set({
        //         start: null,
        //         finish: null,
        //         duration: 0
        //     }, {silent: true});
        //     this.startPicker.setValue(null);
        //     this.finishPicker.setValue(null);
        //     this.$('.input-duration').attr('disabled', true);
        // }
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    addDependency: function () {
        if (this.contextDependency != null) {
            let saved = this.saveDependency();
            if (!saved) {
                return;
            }
        }

        this.contextDependency = new PJQ.models.schedule.TaskDependency({
            taskId: this.model.id,
            dependTaskId: 0,
            offset: 0
        });
        this.renderDependencies();
    },
    addSuccessor: function () {
        if (this.contextDependency != null) {
            let saved = this.saveDependency();
            if (!saved) {
                return;
            }
        }

        this.contextDependency = new PJQ.models.schedule.TaskDependency({
            taskId: 0,
            dependTaskId: this.model.id,
            offset: 0
        });
        this.renderDependencies();
    },
    saveDependency: function () {
        let relTaskId = this.dependencyPicker.getValue();
        if (relTaskId == null) {
            this.dependencyPicker.showError();
            return false;
        }

        if (this.contextDependency.get('taskId') === this.model.id) {
            this.contextDependency.set('dependTaskId', relTaskId);
        } else {
            this.contextDependency.set('taskId', relTaskId);
        }
        let offset = parseInt(this.$('.input-dependency-offset').val());
        this.contextDependency.set({
            type: this.dependencyTypePicker.getValue(),
            offset: !isNaN(offset) ? offset : 0
        });
        this.model.dependencies.add(this.contextDependency);
        this.options.schedule.dependencies.add(this.contextDependency);
        if (!this.contextDependency.get('dependencyId')) {
            this.contextDependency.set('dependencyId', -(this.options.schedule.dependencies.length + 1))
        }
        this.model.isDirty = true;
        this.contextDependency = null;
        this.renderDependencies();

        let minStart = this.model.getMinStart();
        if (this.model.get('start') == null || PJQ.helpers.dateHelpers.getDateDaysDiff(minStart, this.model.get('start'), !this.model.get('weekendWork')) > 0) {
            this.model.set({
                start: minStart,
                finish: PJQ.helpers.dateHelpers.getNewDateAddDays(minStart, this.model.get('duration'), !this.model.get('weekendWork'), true)
            }, {
                silent: true
            });
            this.startPicker.setValue(this.model.get('start'));
            this.finishPicker.setValue(this.model.get('finish'));
        }

        return true;
    },
    editDependency: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid');
        this.contextDependency = this.model.dependencies.get(cid);
        this.renderDependencies();
    },
    deleteDependency: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            dependency = this.model.dependencies.get(cid),
            scheduleDependency = this.options.schedule.dependencies.get(dependency.get('dependencyId'));
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this " + (dependency.get('taskId') === this.model.id ? 'dependency' : 'successor') + "?",
            onDelete: _.bind(function () {
                if (dependency.id !== 0) {
                    dependency.set('isDeleted', true);
                    scheduleDependency.set('isDeleted', true);
                } else {
                    this.model.dependencies.remove(dependency);
                    this.options.schedule.dependencies.remove(scheduleDependency);
                }
                this.model.isDirty = true;
                this.renderDependencies();
            }, this)
        });
    },
    cancelDependency: function (e) {
        this.contextDependency = null;
        this.renderDependencies();
    },
    renderDependencies: function () {
        this.renderSubTemplate(false, this.options.subTemplates.dependencies, this.$('.dependencies-outer'), {
            model: this.model,
            schedule: this.options.schedule,
            canEdit: this.options.canEdit,
            contextDependency: this.contextDependency
        }, _.bind(function () {
            this.renderSubTemplate(false, this.options.subTemplates.dependencies, this.$('.successors-outer'), {
                model: this.model,
                schedule: this.options.schedule,
                isSuccessor: true,
                canEdit: this.options.canEdit,
                contextDependency: this.contextDependency
            }, _.bind(function () {
                if (this.contextDependency != null) {
                    this.dependencyPicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.select-dependency'),
                        noneSelectedText: 'Select Task',
                        isIntChoices: true,
                        isLiveSearch: true,
                        isBlockSubtext: true,
                        defaultValue: this.contextDependency.get('taskId') === this.model.id ? this.contextDependency.get('dependTaskId') : this.contextDependency.get('taskId')
                    });

                    this.dependencyTypePicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.select-dependency-type'),
                        noneSelectedText: 'Select Type',
                        defaultValue: this.contextDependency.get('type')
                    });
                }
            }, this));
        }, this));

        let minStart = this.model.getMinStart();
        this.startPicker.setMinDate(minStart);
        if (this.finishPicker != null) {
            this.finishPicker.setMinDate(minStart);
        }
    },
    renderRequestedChanges: function () {
        this.renderSubTemplate(false, this.options.subTemplates.requestedChanges, this.$('.requested-changes-outer'), {
            model: this.model,
            requestedChanges: this.model.requestedChanges,
            canEdit: this.options.canManageChangeRequest
        });
    },
    renderComments: function () {
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$('.comments-outer'), {
            comments: this.model.comments.models,
            canEdit: this.options.canEdit
        });
    },
    renderCompletion: function () {
        this.progressSlider = this.$('.progress-slider').bootstrapSlider({
            handle: 'square'
        });

        this.$('#progress-slider').append($('<div>', {
            class: 'font-weight-light fs-14 bg-' + this.options.colorClass + ' text-' + (this.options.colorClass === 'warning' ? 'dark' : 'light')
        }).text(this.model.get('percentComplete') + '%'));

        this.completionChanged();
    },
    disableCompletedNotificationChanged: function () {
        let $message = this.$('.comp-notify-message-outer');
        if (this.model.get('disableCompletedNotification')) {
            $message.addClass('hidden');
        } else {
            $message.removeClass('hidden');
        }
    },
    completionChanged: function () {
        let percent = this.progressSlider.data('bootstrapSlider').getValue(),
            $slider = this.$('.slider-selection'),
            $text = this.$('.progress-percent');
        $text.text(percent + '%');
        $text.removeClass('text-danger').removeClass('text-warning').removeClass('text-success');
        $slider.removeClass('slider-bg-danger bg-danger').removeClass('slider-bg-warning bg-warning')
            .removeClass('slider-bg-success bg-success');
        if (percent < 60) {
            $text.addClass('text-danger');
            $slider.addClass('slider-bg-danger bg-danger');
        } else if (percent >= 60 && percent < 100) {
            $text.addClass('text-warning');
            $slider.addClass('slider-bg-warning bg-warning');
        } else {
            $text.addClass('text-success');
            $slider.addClass('slider-bg-success bg-success');
        }
        if (this.model.get('percentComplete') !== percent) {
            this.model.set('percentComplete', percent);
        }
    },
    viewTask: function (e) {
        this.model = this.model.collection.get($(e.currentTarget).data('cid'));
        this.model.fetch({
            success: _.bind(function () {
                this.render();
                this.modal.scrollTop(0);
            }, this)
        })
    },
    addRequestedChange: function () {
        new PJQ.views.schedule.AddRequestedChangeModal({
            task: this.model,
            isSuccessor: this.options.isSuccessor,
            onSave: _.bind(function (requestedChange) {
                this.model.requestedChanges.add(requestedChange);
                if (this.options.schedule != null) {
                    this.options.schedule.pendingRequestedChanges.add(requestedChange);
                }
                this.renderRequestedChanges();
            }, this)
        });
    },
    deleteRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.requestedChanges.get(cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this requested change?",
            onDelete: _.bind(function () {
                requestedChange.set('isDeleted', true);
                this.model.isDirty = true;
                this.renderRequestedChanges();
            }, this)
        });
    },
    approveRequestedChangeClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.requestedChanges.get(cid),
            newStart = new Date(requestedChange.get('newStart')),
            newFinish = new Date(requestedChange.get('newFinish'));
        if ((newFinish.getDay() === (0 || 6) || newStart.getDay() === (0 || 6)) && !this.model.get('weekendWork')) {
            new PJQ.views.modals.YesNo({
                header: 'Weekend Work',
                body: 'The new start or finish falls on the weekend and approving will enable weekend work. Continue?',
                onYes: _.bind(function () {
                    this.$('.btn-weekend-work')[0].checked = true;
                    this.model.updateWeekendWork(true);
                    this.approveRequestedChange(requestedChange);
                }, this),
                onNo: _.bind(function () {
                    this.approveRequestedChange(requestedChange);
                }, this)
            })
        } else {
            this.approveRequestedChange(requestedChange);
        }
    },
    approveRequestedChange: function (change) {
        let requestedChange = change;
        requestedChange.approve(_.bind(function (res) {
            let newStart = new Date(res.requestedChange.newStart),
                newFinish = new Date(res.requestedChange.newFinish);
            this.model.set({
                start: newStart,
                finish: newFinish
            });
            this.startPicker.setValue(newStart);
            this.finishPicker.setValue(newFinish);
            this.renderRequestedChanges();
        }, this));
    },
    rejectRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.requestedChanges.get(cid);
        requestedChange.reject(_.bind(function (res) {
            this.renderRequestedChanges();
        }, this));
    },
    addComment: function () {
        let val = this.$('.item-new-comment').val().trim();
        if (_.size(val) === 0)
            return;

        let comment = new PJQ.models.schedule.TaskComment({
            taskId: this.model.id,
            commentText: val,
            createdOn: new Date()
        });
        if (!this.model.isNew()) {
            comment.save(null, {
                success: _.bind(function () {
                    this.model.comments.add(comment);
                    this.renderComments();
                }, this)
            });
        } else {
            comment.createdBy = PJQ.app.session.user;
            this.model.comments.add(comment);
            this.renderComments();
        }
        this.$('.item-new-comment').val('');
    },
    validate: function () {
        let isValid = true,
            errorText = "";
        // Check if Task Name is filled out
        let nameValid = this.$('.task-name').val().trim().length === 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.task-name'), !nameValid);
        if (nameValid) {
            errorText += '<li>Task name cannot be empty.</li>';
            isValid = false;
        }

        if (!isValid) {
            if (this.errorAlert != null) {
                this.errorAlert.destroy();
            }
            this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                type: 'danger',
                text: errorText
            });
        }
        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        let fnCheck = _.bind(function (noNotifyTaskIds) {
            if (this.fileUploader.isUploading()) {
                new PJQ.views.BaseModal({
                    header: "Files Uploading",
                    body: "You can't save while files are uploading"
                });
            } else {
                this.$('.modal-footer>button').prop('disabled', true);
                new PJQ.Loader(this.$('.btn-save'), {
                    loadingText: ''
                });

                if (this.contextDependency != null) {
                    let saved = this.saveDependency();
                    if (!saved) {
                        return;
                    }
                }
                if (this.model.hasChanged() || this.model.isNew()) {
                    let fnSave = _.bind(function () {
                        this.model.save({
                            preventNotifyTaskIds: noNotifyTaskIds
                        }, {
                            notify: true,
                            success: _.bind(function () {
                                if (typeof this.options.onSave === 'function') {
                                    this.options.onSave(this.model);
                                }
                                this.removeModal();
                            }, this)
                        });
                    }, this);

                    // this code is designed to just match status names that match "complete" exactly" (not case sensitive)
                    // if the task is 100% and the status is not complete (and they have a complete status)
                    // ask if they want to set it to complete
                    // if the task is complete and not set to 100%, ask if they want to set it to 100%
                    let completeStatus = this.options.statuses.find(function (status) {
                        return status.get('name').toLowerCase() === 'complete';
                    });
                    if (completeStatus != null) {
                        let isCompleteStatus = this.model.status.id !== completeStatus.id,
                            header = null,
                            body = null,
                            compSpan = '<strong style="color:' + completeStatus.get('color') + '">Complete</strong>';
                        if (this.model.get('percentComplete') === 100 && isCompleteStatus) {
                            header = 'Mark as Complete?';
                            body = 'This task is marked as 100% complete.  Would you like to change the status to ' + compSpan + '?';
                        } else if (this.model.get('percentComplete') < 100 && !isCompleteStatus) {
                            header = 'Mark as Complete?';
                            body = 'This task is marked as ' + compSpan + '.  Would you like to change the progress to 100%?';
                        }

                        if (header != null && body != null) {
                            new PJQ.views.modals.YesNo({
                                header: header,
                                body: body,
                                onYes: _.bind(function () {
                                    this.model.set('percentComplete', 100);
                                    this.model.status = completeStatus;
                                    fnSave();
                                }, this),
                                onNo: _.bind(function () {
                                    fnSave();
                                }, this)
                            });
                        } else {
                            fnSave();
                        }
                    } else {
                        fnSave();
                    }
                } else {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }
            }
        }, this);
        if (this.model.get('projectId') > 0 && this.settings.get('notificationsEnabled') && this.settings.get('dateChangeNotificationsMode') === 1) {
            let changedTasks = this.model.determineChangedTasks();
            if (_.size(changedTasks) > 0) {
                new PJQ.views.schedule.TaskChangeNotifications({
                    changedTasks: changedTasks,
                    onSave: _.bind(function (res) {
                        fnCheck(res.noNotify);
                    }, this)
                });
            } else {
                fnCheck();
            }
        } else {
            fnCheck();
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this task?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.schedule.AddRequestedChangeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Add-Requested-Change'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.schedule.RequestedChange({
            taskId: this.options.task.id,
            oldStart: this.options.task.get('start'),
            oldFinish: this.options.task.get('finish'),
            newStart: this.options.task.get('start'),
            newFinish: this.options.task.get('finish')
        });
    },
    renderData: function () {
        return {
            model: this.model,
            isSuccessor: this.options.isSuccessor
        };
    },
    afterRender: function () {
        this.startPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-new-start'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('newStart'),
                minDate: this.options.task.getMinStart()
            },
            onChange: _.bind(function (newDate) {
                this.model.set('newStart', newDate);
            }, this)
        });

        this.finishPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-new-finish'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('newFinish')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('newFinish', newDate);
            }, this)
        });
    },
    save: function () {
        let $reason = this.$('.input-reason'),
            reason = $reason.val();

        let isValid = true;
        if (this.model.get('newStart') == null) {
            this.startPicker.showError();
            isValid = false;
        } else {
            this.startPicker.hideError();
        }

        if (this.model.get('newFinish') == null) {
            this.finishPicker.showError();
            isValid = false;
        } else {
            this.finishPicker.hideError();
        }

        if (_.size(reason) === 0) {
            PJQ.helpers.inputHelpers.setInputError($reason, false);
            isValid = false;
        } else {
            PJQ.helpers.inputHelpers.setInputError($reason, true);
        }

        if (isValid) {
            this.model.save({
                reason: reason
            }, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Change request submitted'
                    });
                }, this)
            });
        }
    }
});

PJQ.views.schedule.TaskChangeNotifications = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Change-Notifications'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'change .cb-notify-task': 'changeNotifyTask',
        'change .cb-notify-none': 'changeNotifyNone',
        'click .btn-save': 'save'
    },
    renderData: function () {
        return {
            changedTasks: this.options.changedTasks
        };
    },
    changeNotifyTask: function () {
        this.$('.cb-notify-none').prop('checked', _.size(this.$('.cb-notify-task:checked')) === 0);
    },
    changeNotifyNone: function () {
        if (this.$('.cb-notify-none').prop('checked')) {
            this.$('.cb-notify-task').prop('checked', false);
        }
    },
    save: function () {
        let notify = [],
            noNotify = [];
        this.$('.cb-notify-task').each(function () {
            if ($(this).is(':checked')) {
                notify.push($(this).data('id'));
            } else {
                noNotify.push($(this).data('id'));
            }
        });
        if (typeof this.options.onSave === 'function') {
            this.options.onSave({
                notify: notify,
                noNotify: noNotify
            });
        }
        this.removeModal();
    }
});

PJQ.views.schedule.NewLookAheadModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'modal-edit-lookahead'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: async function () {
        if (this.model == null) {
            this.model = new PJQ.models.schedule.LookAhead({
                projectId: this.options.projectId
            });
        }

        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            lookAheads: this.options.lookAheads
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'select'
            ]
        });

        let minStart = null;
        if (this.options.lookAheads != null && _.size(this.options.lookAheads.models) > 0) {
            minStart = _.max(_.map(this.options.lookAheads.models, (lookAhead) => {
                return new Date(PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(lookAhead.get('start')), lookAhead.get('duration')));
            }));
        }

        if (minStart == null) {
            minStart = new Date();
        }

        if (this.model.get('start') == null) {
            this.model.set('start', minStart);
        }
        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-start-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.getDateString(minStart, PJQ.helpers.dateHelpers.dateFormats.DATE, true)
            },
            onChange: (newDate) => {
                this.model.set('start', newDate);
            }
        });

        if (this.model.get('duration') == null) {
            this.model.set('duration', 14);
        }
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-duration'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('duration')
        });

        if (this.options.lookAheads != null && _.size(this.options.lookAheads.models) > 0) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-use-look-ahead'),
                isIntChoices: true,
                isMultiple: false,
                defaultValue: 2,
                choices: _.map(this.options.lookAheads.models, (lookAhead) => {
                    return {
                        name: lookAhead.getDisplayName(),
                        value: lookAhead.id
                    };
                })
                // onChange: (value) => {
                //     this.model.set('')
                // }
            });
        }
    },
    validate: function () {
        if (this.validationAlert != null) {
            this.validationAlert.destroy();
        }

        if (this.options.schedule != null) {
            let lookAheadStart = new Date(this.model.get('start')),
                lookAheadFinish = PJQ.helpers.dateHelpers.getNewDateAddDays(lookAheadStart, this.model.get('duration'));
            if (null == _.find(this.options.schedule.tasks.models, (task) => {
                return PJQ.helpers.dateHelpers.checkDateRangesOverlap(task.get('start'), task.get('finish'), lookAheadStart, lookAheadFinish);
            })) {
                this.validationAlert = new PJQ.Alert(this.$('.modal-body'), {
                    text: "The Look Ahead date range does not contain with any tasks in the schedule. Please select a different date range.",
                    isPrepend: true,
                    type: 'warning'
                });
                return false;
            }
        }
        return true;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Schedule Look-Ahead created successfully',
                });
                this.removeModal();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            },
            error: (model, response) => {
                // this.showErrors(response.responseJSON);
            }
        });
    },
    // deleteTemplate: function () {
    // 	new PJQ.views.modals.DeleteCancel({
    // 		header: "Confirm Deletion",
    // 		body: "Are you sure you want to delete this template?",
    // 		onDelete: _.bind(function () {
    // 			if (typeof this.options.onDelete === 'function') {
    // 				this.options.onDelete(this.model);
    // 			}
    // 			this.removeModal();
    // 		}, this)
    // 	});
    // }
});
// Models
PJQ.models.schedule.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyAssignees',
                value: this.get('copyAssignees')
            },
            {
                parameter: 'copyDependencies',
                value: this.get('copyDependencies')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copyAttachments',
                value: this.get('copyAttachments')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.statuses = new PJQ.collections.schedule.TaskStatuses(model.statuses);
        PJQ.app.session.scheduleTaskStatuses = this.statuses;

        this.dependencies = new PJQ.collections.schedule.TaskDependencies(model.dependencies);

        this.pendingRequestedChanges = new PJQ.collections.schedule.RequestedChanges(model.requestedChanges);

        this.tasks = new PJQ.collections.schedule.Tasks();
        if (model.tasks) {
            _.each(model.tasks, function (task) {
                this.tasks.add(new this.tasks.model(_.defaults({
                    status: task.status != null ? task.status : this.statuses.get(task.statusId),
                    requestedChanges: _.filter(this.pendingRequestedChanges.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId;
                    }),
                    dependencies: _.filter(this.dependencies.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId || dependency.get('dependTaskId') === task.taskId;
                    })
                }, task)));
            }, this);
        }

        return model;
    }
});

PJQ.models.schedule.LookAhead = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    notifyName: 'Look-Ahead',
    endpoint: function () {
        let params = [];
        if(this.get('canStartBeforeRange')){
            params.push({
                parameter: 'canStartBeforeRange',
                value: true
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'lookaheads',
                value: this.id
            }
        ], params);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.statuses = new PJQ.collections.schedule.TaskStatuses(model.statuses);
        PJQ.app.session.scheduleTaskStatuses = this.statuses;

        this.dependencies = new PJQ.collections.schedule.TaskDependencies(model.dependencies);

        this.pendingRequestedChanges = new PJQ.collections.schedule.RequestedChanges(model.requestedChanges);

        this.tasks = new PJQ.collections.schedule.Tasks();
        if (model.tasks) {
            _.each(model.tasks, function (task) {
                this.tasks.add(new this.tasks.model(_.defaults({
                    status: task.status != null ? task.status : this.statuses.get(task.statusId),
                    requestedChanges: _.filter(this.pendingRequestedChanges.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId;
                    }),
                    dependencies: _.filter(this.dependencies.models, function (dependency) {
                        return dependency.get('taskId') === task.taskId || dependency.get('dependTaskId') === task.taskId;
                    })
                }, task)));
            }, this);
        }

        return model;
    },
    getDisplayName: function (actual) {
        let start, finish;
        if (actual) {
            start = new Date(this.get('tasksStart'));
            finish = new Date(this.get('tasksFinish'));
            if (start == null || finish == null) {
                return "";
            }
        } else {
            start = new Date(this.get('start'));
            finish = PJQ.helpers.dateHelpers.getNewDateAddDays(start, this.get('duration'));
        }

        let startStr = PJQ.helpers.dateHelpers.getDateString(start, PJQ.helpers.dateHelpers.dateFormats.DATE, true),
            finishStr = PJQ.helpers.dateHelpers.getDateString(finish, PJQ.helpers.dateHelpers.dateFormats.DATE, true);
        return startStr + ' - ' + finishStr;
    },
    share: function (shareData, callback) {
        let sh = new PJQ.models.schedule.ScheduleShare(_.defaults(shareData ? shareData : {}, {
            projectId: this.get('projectId'),
            lookAheadId: this.id
        }));
        sh.save(null, {
            success: function () {
                if (typeof callback === 'function') {
                    callback(sh);
                }
            }
        });
    }
});

PJQ.models.schedule.ScheduleShare = PJQ.models.BaseModel.extend({
    idAttribute: 'accessKey',
    notifyName: 'Schedule',
    endpoint: function () {
        if (this.get('projectId') > 0) {
            let params = [];
            if (this.get('lookAheadId') > 0) {
                params.push({
                    parameter: 'lookAheadId',
                    value: this.get('lookAheadId')
                });
            }

            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'share'
                }
            ], params);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'share',
                value: this.id
            }
        ]);
    }
});

PJQ.models.schedule.Schedule = PJQ.models.schedule.Template.extend({
    notifyName: 'Schedule',
    endpoint: function () {
        let arr;
        if (this.get('projectId') != null) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'schedule'
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    share: function (shareData, callback) {
        let sh = new PJQ.models.schedule.ScheduleShare(_.defaults(shareData ? shareData : {}, {
            projectId: this.get('projectId')
        }));
        sh.save(null, {
            success: function () {
                if (typeof callback === 'function') {
                    callback(sh);
                }
            }
        });
    }
});

PJQ.models.schedule.Task = PJQ.models.BaseModel.extend({
    notifyName: 'Task',
    idAttribute: 'taskId',
    endpoint: function (urlOptions) {
        let arr;
        if (this.isNew() && this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks'
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'tasks'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks',
                    value: this.id
                }
            ]
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(arr)
    },
    parse: function (model) {
        model = _.defaults(model ? model : {}, {
            name: "",
            duration: 1,
            start: null,
            finish: null,
            weekendWork: false,
            isAllDay: true,
            isMilestone: false,
            percentComplete: 0,
            notes: "",
            lookAheadId: null,
            projectId: null,
            templateId: null
        });

        //if the parsed value is an array, this was a save response that returned multiple tasks
        //the multiple tasks are returned because dependency relationships caused other tasks to be modified
        if (model.changes != null) {
            this.set('taskId', model.task.taskId);
            if (this.collection != null) {
                _.each(model.changes, function (task) {
                    let colTask = this.collection.get(task.taskId);
                    if(colTask == null){
                        return;
                    }

                    task.start = PJQ.helpers.dateHelpers.parseDateString(task.start, false);
                    task.finish = PJQ.helpers.dateHelpers.parseDateString(task.finish, false);
                    colTask.set({
                        start: task.start,
                        finish: task.finish
                    });
                }, this);
            }
            model = model.task;
        }

        if (model.subTasks != null) {
            this.subTasks = new PJQ.collections.schedule.Tasks(model.subTasks);
        }

        if (model.project != null) {
            this.project = model.project;
        }

        if (model.status != null) {
            this.status = model.status;
        } else if ((PJQ.app.session.scheduleTaskStatuses != null)) {
            if (model.statusId > 0) {
                this.status = PJQ.app.session.scheduleTaskStatuses.get(model.statusId);
            } else {
                this.status = PJQ.app.session.scheduleTaskStatuses.getDefault();
            }
        }

        if (_.size(model.start) > 0) {
            model.start = typeof model.start === 'string' ? PJQ.helpers.dateHelpers.parseDateString(model.start, false) : model.start;
        }

        if (_.size(model.finish) > 0) {
            model.finish = typeof model.finish === 'string' ? PJQ.helpers.dateHelpers.parseDateString(model.finish, false) : model.finish;
        }

        this.assignees = new PJQ.collections.projectContacts.ProjectContacts(model.assignees);
        this.groups = new PJQ.collections.groups.Groups(model.groups);
        this.comments = new PJQ.collections.schedule.TaskComments(model.comments);
        this.attachments = new PJQ.collections.schedule.ScheduleTaskAttachments(model.attachments);

        if (PJQ.helpers.objectHelpers.refinedType(model.requestedChanges, true) === 'backboneCollection') {
            this.requestedChanges = model.requestedChanges;
        } else {
            this.requestedChanges = new PJQ.collections.schedule.RequestedChanges(model.requestedChanges);
        }

        if (_.size(model.dependencies) > 0) {
            if (PJQ.helpers.objectHelpers.refinedType(model.dependencies, true) === 'backboneCollection') {
                this.dependencies = model.dependencies;
            } else {
                this.dependencies = new PJQ.collections.schedule.TaskDependencies(model.dependencies);
            }
        } else if (this.dependencies == null) {
            this.dependencies = new PJQ.collections.schedule.TaskDependencies();
        }

        return model;
    },
    getSummaryTaskName: function (tasks) {
        let summaryTaskId = this.get('summaryTaskId'),
            name = '';
        if (summaryTaskId > 0) {
            let summaryTask = tasks.get(this.get('summaryTaskId'));
            if (summaryTask != null) {
                name += summaryTask.getSummaryTaskName(tasks) + summaryTask.get('name') + ' > ';
            }
        }
        return name;
    },
    getMinStart: function () {
        if (this.collection == null) {
            return null;
        }

        let deps = this.getDependencies();
        if (_.size(deps) === 0) {
            return null;
        }

        return _.max(_.map(deps, function (dep) {
            let depTask = this.collection.get(dep.get('dependTaskId'));
            if (dep.get('type') === PJQ.constants.schedule.dependencyTypes.START_START) {
                if (dep.get('offset') !== 0) {
                    return depTask.get('start');
                }
                return PJQ.helpers.dateHelpers.getNewDateAddDays(depTask.get('finish'), dep.get('offset'), !this.get('weekendWork'));
            } else if (dep.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START) {
                return PJQ.helpers.dateHelpers.getNewDateAddDays(depTask.get('finish'), 1 + dep.get('offset'), !this.get('weekendWork'));
            }
            return null;
        }, this));
    },
    getDependencies: function () {
        return _.filter(this.dependencies.models, function (dependency) {
            return dependency.get('taskId') === this.id && !dependency.get('isDeleted');
        }, this);
    },
    getSuccessors: function () {
        return _.filter(this.dependencies.models, function (dependency) {
            return dependency.get('dependTaskId') === this.id && !dependency.get('isDeleted');
        }, this);
    },
    updateWeekendWork: function (weekendWork) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks',
                    value: this.get('taskId')
                },
                {
                    endpoint: 'updateweekendwork'
                },
            ], [
                {
                    parameter: 'weekendWork',
                    value: weekendWork
                }
            ]),
        }).put().done(_.bind(function () {
            this.set('weekendWork', weekendWork);
        }, this));
    },
    determineChangedTasks: function (assignedOnly = true) {
        let result = [],
            resultIds = [],
            fnCheckDeps = _.bind(function (taskData) {
                _.each(taskData.task.getSuccessors(), function (successor) {
                    if (resultIds.indexOf(successor.get('taskId')) !== -1) {
                        return;
                    }

                    let successorTask = this.collection.get(successor.get('taskId')),
                        cTaskData = null;
                    if (assignedOnly && _.size(successorTask.assignees) === 0) {
                        return;
                    }

                    if (successor.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START && PJQ.helpers.dateHelpers.getDateDaysDiff(successorTask.get('start'), taskData.newFinish, !successorTask.get('weekendWork')) <= 0) {
                        let newStart = PJQ.helpers.dateHelpers.getNewDateAddDays(taskData.newFinish, 1, !successorTask.get('weekendWork'));
                        cTaskData = {
                            task: successorTask,
                            newStart: newStart,
                            newFinish: PJQ.helpers.dateHelpers.getNewDateAddDays(newStart, successorTask.get('duration'), !successorTask.get('weekendWork'), true)
                        };
                    } else if (successor.get('type') === PJQ.constants.schedule.dependencyTypes.START_START && PJQ.helpers.dateHelpers.getDateDaysDiff(successorTask.get('start'), taskData.newStart, !successorTask.get('weekendWork')) <= 0) {
                        cTaskData = {
                            task: successorTask,
                            newStart: taskData.newStart,
                            newFinish: PJQ.helpers.dateHelpers.getNewDateAddDays(taskData.newStart, successorTask.get('duration'), !successorTask.get('weekendWork'), true)
                        };
                    }
                    if (cTaskData != null) {
                        result.push(cTaskData);
                        resultIds.push(successor.get('taskId'));
                        fnCheckDeps(cTaskData);
                    }
                }, this);
            }, this);

        if (this.id > 0 && (!assignedOnly || _.size(this.assignees) > 0) && (0 !== PJQ.helpers.dateHelpers.getDateDaysDiff(this.initAttributes.start, this.attributes.start, false) || 0 !== PJQ.helpers.dateHelpers.getDateDaysDiff(this.initAttributes.finish, this.attributes.finish, false))) {
            result.push({
                task: this,
                newStart: this.get('start'),
                newFinish: this.get('finish')
            });
            resultIds.push(this.id);
        }
        fnCheckDeps({
            task: this,
            newStart: this.get('start'),
            newFinish: this.get('finish')
        });
        return result;
    },
    getGanttTask: function () {
        return new PJQ.models.charts.GanttTask({
            id: this.id,
            model: this,
            name: this.get('name'),
            start: this.get('start'),
            end: this.get('finish'),
            duration: this.get('duration'),
            isMilestone: this.get('isMilestone'),
            thumbnail: this.get('isMilestone') ? 'https://app.panteratools.com//assets/libs/svgs/light/flag.svg' : null,
            progress: this.get('percentComplete'),
            dependencies: _.map(this.getDependencies(), function (dep) {
                return dep.get('dependTaskId');
            }),
            style: this.status != null ? 'fill: ' + this.status.get('color') : 'fill: #6c757d',
            textColor: '#4CAF50'
        });
    },
    getCalendarTask: function (tasks) {
        return new PJQ.models.calendars.CalendarTask({
            id: this.id,
            model: this,
            title: this.getCalendarTaskTitle(tasks),
            isMilestone: this.get('isMilestone'),
            start: this.get('start'),
            progress: this.get('percentComplete'),
            end: PJQ.helpers.dateHelpers.getNewDateAddDays(this.get('finish'), 1),
            allDay: this.get('isAllDay'),
            backgroundColor: (this.status ? this.status.get('color') : '#6c757d') + ' !important',
            borderColor: (this.status ? this.status.get('color') : '#6c757d') + ' !important'
        });
    },
    getCalendarTaskTitle: function (tasks) {
        let name = this.getSummaryTaskName(tasks) + this.get('name'),
            assigneesArray = [];
        _.each(this.assignees.models, function (assignee) {
            let cName = _.size(assignee.get('contactName')) > 0 ? assignee.get('contactName') : assignee.get('companyName');
            if (_.size(cName) > 0) {
                assigneesArray.push(cName);
            }
        }, this)

        if (_.size(assigneesArray) >= 1) {
            return name + " (" + assigneesArray.join(', ') + ')';
        } else {
            return name;
        }
    },
    beforeSave: function () {
        this.set('statusId', this.status != null ? this.status.id : 0);
        this.set('assignees', this.assignees.toJSON());
        this.set('groups', this.groups.toJSON());
        this.set('dependencies', this.dependencies.getChangedModels());
        this.set('requestedChanges', this.requestedChanges.getChangedModels());
        this.set('attachments', this.attachments.getChangedModels());
    },
    afterSave: function () {
        if (this.collection != null) {
            _.each(this.dependencies.models, function (dep) {
                let relTaskId;
                if (dep.get('taskId') !== this.id) {
                    relTaskId = dep.get('taskId');
                } else {
                    relTaskId = dep.get('dependTaskId');
                }

                let relTask = this.collection.get(relTaskId);
                if (relTask != null) {
                    let relDep = relTask.dependencies.where({
                        taskId: dep.get('taskId'),
                        dependTaskId: dep.get('dependTaskId')
                    });
                    if (relDep == null && !dep.get('isDeleted')) {
                        relTask.dependencies.add(dep);
                    } else if (dep.get('isDeleted')) {
                        relTask.dependencies.remove(dep);
                    }
                }
            }, this);
        }
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.schedule.Notifications(null, {
                taskId: this.id
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    newDependencyTask: function () {
        let start = PJQ.helpers.dateHelpers.getNewDateAddDays(this.get('start'), -1, !this.get('weekendWork')),
            newTask = new PJQ.models.schedule.Task({
                projectId: this.get('projectId'),
                templateId: this.get('templateId'),
                start: start,
                finish: start
            });
        newTask.dependencies.add({
            taskId: this.id,
            dependTaskId: newTask.id,
            type: PJQ.constants.schedule.dependencyTypes.FINISH_START,
            offset: 0
        });
        return newTask;
    },
    newSuccessorTask: function () {
        let start = PJQ.helpers.dateHelpers.getNewDateAddDays(this.get('finish'), 1, !this.get('weekendWork')),
            newTask = new PJQ.models.schedule.Task({
                projectId: this.get('projectId'),
                templateId: this.get('templateId'),
                start: start,
                finish: start
            });
        newTask.dependencies.add({
            taskId: newTask.id,
            dependTaskId: this.id,
            type: PJQ.constants.schedule.dependencyTypes.FINISH_START,
            offset: 0
        });
        return newTask;
    }
});

PJQ.models.schedule.TaskDependency = PJQ.models.BaseModel.extend({
    notifyName: 'Dependency',
    idAttribute: 'dependencyId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'dependencies',
                value: this.id
            }
        ]);
    },
    getTooltip: function (tasks) {
        let result,
            dependTask = _.find(tasks.models, function (task) {
                return this.get('dependTaskId') === task.id;
            }, this),
            task = _.find(tasks.models, function (task) {
                return this.get('taskId') === task.id;
            }, this);
        if (this.get('offset') > 0 || this.get('offset') < 0) {
            result = task.get('name') + ' can start no earlier than ' + (this.get('offset') > 0 ? (this.get('offset') + ' days after ') : (-this.get('offset') + ' days before ')) + dependTask.get('name') + (this.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START ? ' finishes' : ' starts');
        } else {
            result = dependTask.get('name') + ' must ' + (this.get('type') === PJQ.constants.schedule.dependencyTypes.FINISH_START ? 'finish' : 'start') + ' before ' + task.get('name') + ' can start';
        }
        return result;
    }
});

PJQ.models.schedule.RequestedChange = PJQ.models.BaseModel.extend({
    notifyName: 'Requested Change',
    idAttribute: 'changeId',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'changes',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'changes'
            }
        ]);
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.newStart != null) {
            model.newStart = PJQ.helpers.dateHelpers.parseDateString(model.newStart, false);
            model.newFinish = PJQ.helpers.dateHelpers.parseDateString(model.newFinish, false);
        }

        if (model.oldStart != null) {
            model.oldStart = PJQ.helpers.dateHelpers.parseDateString(model.oldStart, false);
            model.oldFinish = PJQ.helpers.dateHelpers.parseDateString(model.oldFinish, false);
        }
        return model;
    },
    approve: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/approve',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.set(response.requestedChange);
            if (typeof callback === 'function') {
                callback(response);
            }
        }, this));
    },
    reject: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reject',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.set(response);
            if (typeof callback === 'function') {
                callback(response);
            }
        }, this));
    },
});

PJQ.models.schedule.TaskStatus = PJQ.models.BaseModel.extend({
    notifyName: 'Status',
    idAttribute: 'statusId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'statuses',
                value: this.id
            }
        ]);
    }
});

PJQ.models.schedule.ScheduleTaskAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.schedule.TaskComment = PJQ.models.BaseModel.extend({
    notifyName: 'Comment',
    idAttribute: 'commentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model) {
            return model;
        }
        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }
        return model;
    }
});

PJQ.models.schedule.Settings = PJQ.models.BaseModel.extend({
    notifyName: 'Schedule Settings',
    idAttribute: 'userId',
    endpoint: function () {
        if (this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        this.lookAheadManagers = new PJQ.collections.projectContacts.ProjectContacts(model.lookAheadManagers);
        return model;
    },
    beforeSave: function () {
        this.set('lookAheadManagers', this.lookAheadManagers.toJSON());
    },
});

PJQ.models.schedule.TaskListItemGroup = PJQ.models.BaseModel.extend({});

// Collections
PJQ.collections.schedule.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});

PJQ.collections.schedule.LookAheads = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.LookAhead,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'lookaheads'
            }
        ]);
    }
});

PJQ.collections.schedule.Tasks = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.Task,
    getGanttTasks: function () {
        let sortedModels = _.sortBy(this.models, function (model) {
            if (model.get('start') != null) {
                return new Date(model.get('start'));
            }
        });
        let fnGetSubtasks = _.bind(function (task) {
                let subTasks = _.filter(sortedModels, function (model) {
                    return model.get('summaryTaskId') === task.id && model.id !== task.id;
                });
                _.each(subTasks, function (subTask) {
                    subTasks.push(...fnGetSubtasks(subTask));
                });
                return subTasks;
            }, this),
            tasks = [];
        _.each(sortedModels, function (model) {
            if (model.get('summaryTaskId') > 0) {
                return;
            }

            tasks.push(model.getGanttTask());
            _.each(fnGetSubtasks(model), function (subTask) {
                tasks.push(subTask.getGanttTask());
            })
        });
        return new PJQ.collections.charts.GanttTasks(tasks);
    },
    getCalendarTasks: function () {
        return new PJQ.collections.calendars.CalendarTasks(_.map(_.filter(this.models, function (model) {
            return !model.get('isSummaryTask');
        }), function (model) {
            return model.getCalendarTask(this);
        }, this));
    },
    getValidDependencies: function (task, explicitAllow = null) {
        // tasks that cannot be dependencies:
        // existing successors (recursively)
        // dependencies that already exist
        let invalidTaskIds = [],
            fnCheck = _.bind(function (deps) {
                _.each(deps, function (dep) {
                    let tId = dep.get('taskId');
                    invalidTaskIds.push(tId);
                    fnCheck(this.get(tId).getSuccessors());
                }, this);
            }, this);
        fnCheck(task.getSuccessors());
        invalidTaskIds.push(..._.map(task.getDependencies(), function (dep) {
            return dep.get('dependTaskId');
        }));
        return _.filter(this.models, function (checkTask) {
            return (explicitAllow != null && explicitAllow === checkTask.id) || (checkTask.id !== task.id && invalidTaskIds.indexOf(checkTask.id) === -1);
        });
    },
    getValidSuccessors: function (task, explicitAllow = null) {
        // tasks that cannot be successors:
        // existing dependencies (recursively)
        // successors that already exist
        let invalidTaskIds = [],
            fnCheck = _.bind(function (deps) {
                _.each(deps, function (dep) {
                    let tId = dep.get('dependTaskId');
                    invalidTaskIds.push(tId);
                    fnCheck(this.get(tId).getDependencies());
                }, this);
            }, this);
        fnCheck(task.getDependencies());
        invalidTaskIds.push(..._.map(task.getSuccessors(), function (dep) {
            return dep.get('taskId');
        }));
        return _.filter(this.models, function (checkTask) {
            return (explicitAllow != null && explicitAllow === checkTask.id) || checkTask.id !== task.id && invalidTaskIds.indexOf(checkTask.id) === -1;
        });
    }
});

PJQ.models.schedule.ScheduleCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ])
    }
});

PJQ.models.schedule.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.schedule.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.get('taskId') ? this.get('taskId') : this.collection.options.task.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

//Collections
PJQ.collections.schedule.TaskDependencies = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.TaskDependency
});

PJQ.collections.schedule.RequestedChanges = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.RequestedChange
});

PJQ.collections.schedule.TaskStatuses = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.TaskStatus,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'statuses'
            }
        ]);
    },
    getDefault: function () {
        let def = this.findWhere({isDefault: true});
        if (def == null && this.length > 0) {
            def = this.models[0];
        }
        return def != null ? def : null;
    },
    copy: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'statuses'
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (statuses) {
            this.reset(statuses);
            callback();
        }, this));

    }
});

PJQ.collections.schedule.TaskComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.TaskComment
});

PJQ.collections.schedule.ScheduleTaskAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.schedule.ScheduleTaskAttachment
});

PJQ.collections.schedule.ScheduleCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.schedule.ScheduleCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        let arr;
        if (this.get('projectId') != null) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.options.project ? this.options.project.id : null
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'customFields'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'customFields'
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

PJQ.collections.schedule.Notifications = PJQ.collections.notifications.Notifications.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.schedule.Notification,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'notifications'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'tasks',
                value: this.options.taskId
            },
            {
                endpoint: 'notifications'
            }
        ]);
    }
});

PJQ.views.schedule.SettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Settings'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-delete-tasks': 'deleteTasks'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.schedule.Settings({
                projectId: this.options.project != null ? this.options.project.id : null
            });
        }
        if (!this.model.isFetched) {
            this.model.fetch({
                success: function () {
                    this.render();
                }
            });
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        if (!this.model.isFetched) {
            return;
        }

        new PJQ.views.schedule.Settings({
            el: this.$('.settings-outer'),
            model: this.model,
            project: this.options.project
        });
    },
    deleteTasks: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete all tasks on this schedule?",
            onDelete: _.bind(function () {
                this.options.project.deleteAllScheduleTasks(_.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }, this));
            }, this)
        });
    },
    save: function () {
        if (this.model.hasChanged()) {
            this.model.save({}, {
                notify: true,
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.schedule.Settings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Settings'),
        onChange: null
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeFirstRender: function () {
        if (this.model == null) {
            this.model = new PJQ.models.schedule.Settings({
                projectId: this.options.project != null ? this.options.project.id : null
            });
        }
        this.listenTo(this.model, 'change:notificationsEnabled', function () {
            let $notifications = this.$('.notification-settings');
            if (this.model.get('notificationsEnabled')) {
                $notifications.removeClass('hidden');
            } else {
                $notifications.addClass('hidden');
            }
        });

        let listen = _.bind(function () {
            if (typeof this.options.onChange === 'function') {
                this.listenTo(this.model, 'change', function () {
                    this.options.onChange(this.model);
                });
            }
        }, this);
        if (!this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    listen();
                    this.render();
                }, this)
            });
        } else {
            listen();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        if (!this.model.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (this.options.project != null) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.look-ahead-managers'),
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                selectedContact: this.model.lookAheadManagers.models,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.lookAheadManagers.reset(selectedContacts);
                    this.model.set('isDirty', true);
                }, this)
            });
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-view'),
            defaultValue: this.model.get('defaultView') ? this.model.get('defaultView') : 'view_group',
            onChange: _.bind(function (value) {
                this.model.set('defaultView', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-date-change-notif-mode'),
            defaultValue: this.model.get('dateChangeNotificationsMode'),
            onChange: _.bind(function (value) {
                this.model.set('dateChangeNotificationsMode', value);
            }, this)
        });
    }
});

PJQ.views.schedule.TaskStatuses = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Schedule-Statuses')
    },
    events: {
        'click .add-task-status': 'addClicked',
        'click .edit-task-status': 'editClicked',
        'click .delete-task-status': 'deleteClicked',
        'click .save-task-status': 'statusSave',
        'click .cancel-edit-task-status': 'cancelEditStatus',
        'colorpickerChange': 'setBGColor',
        'keyup .colorpicker-input-box': 'setBGColor'
    },
    beforeFirstRender: function () {
        this.taskStatusContext = null;
        this.collection = new PJQ.collections.schedule.TaskStatuses();
        this.collection.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    renderData: function () {
        return {};
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".task-status-table"),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            sortableOptions: {
                data: this.collection
            },
            targets: 'no-sort',
            pageLength: 50,
            bSort: false,
            language: {
                zeroRecords: 'Click "Add" to create a new Task Status'
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data, type, row) {
                        return '<div><i class="fas fa-sort"></i></div>';
                    }, this)
                },
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name') && this.taskStatusContext.get('sortOrder') === row.get('sortOrder')) {
                                return '<input type="text" class="form-control input-task-status min-wd-200p" value="' + row.get('name') + '">';
                            } else {
                                return '<span style="color:' + row.get('color') + ';">' + row.get('name') + '</span>';
                            }
                        }, this)
                    },
                    "title": "Status"
                },
                {
                    "data": "",
                    "title": "Default",
                    "width": "80px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = row.get('isDefault') === true ? "Yes" : "No";
                        if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name') && this.taskStatusContext.get('sortOrder') === row.get('sortOrder')) {
                            content = '<div class="pretty p-switch mr-1 wd-120p mr-2 ml-2">\n' +
                                '                <input type="checkbox" class="input-default-status"\n' +
                                '                       />\n' +
                                '                <div class="state p-primary">\n' +
                                '                    <label><span class="fs-16">&nbsp;</span></label>\n' +
                                '                </div>\n' +
                                '            </div>'
                        }
                        if (this.taskStatusContext != null && this.taskStatusContext.get('isDefault') === true) {
                            this.$('.input-default-status').prop('checked', true);
                            this.$('.input-default-status').prop('disabled', true);
                        } else {
                            this.$('.input-default-status').prop('checked', false);
                            this.$('.input-default-status').prop('disabled', false);
                        }

                        return '<div>' + content + '</div>'
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "250px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name')) {
                            return '<div class="input-group task-status-color-input min-wd-200p"><input type="text" class="form-control colorpicker-input-box"/><span class="input-group-append"><div class="input-group color-picker"><span class="input-group-text colorpicker-input-addon"><i></i></span></div></span></div>'
                        }
                        return '<div>' + content + '</div>'
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.taskStatusContext != null && this.taskStatusContext.get('name') === row.get('name')) {
                            content = '<button type="button" class="btn btn-success save-task-status wd-30p ml-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger cancel-edit-task-status wd-30p ml-1"><i class="fal fa-times"></i></button>';
                        } else {
                            let disabledAttr = this.taskStatusContext != null ? ' disabled ' : '';
                            content = '<button type="button" class="btn btn-info edit-task-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-task-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover">' + content + '</div>'
                    }, this),
                    "width": "110px",
                }
            ],
        });
    },
    addClicked: function () {
        this.taskStatusContext = null;
        if (this.collection.models.length > 0 && this.collection.models[0].get('userId') === -1)
            this.copyDefaultStatuses(_.bind(this.addStatus, this));
        else
            this.addStatus();
    },
    addStatus: function () {
        let newStatus = new PJQ.models.schedule.TaskStatus({
            name: "",
            color: "#000000",
            isDefault: false,
            sortOrder: this.collection.models.length + 1,
        });
        this.dataTable.addRow(newStatus);
        this.taskStatusContext = newStatus;
        this.$('.add-task-status').prop('disabled', true);
        this.dataTable.refresh();
        this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
            format: 'hex',
            color: this.taskStatusContext.get('color'),
            autoInputFallback: false
        });
        this.$('.colorpicker-input-box').val(this.taskStatusContext.get('color'));
        this.$('.input-task-status').css('color', this.taskStatusContext.get('color'));
    },
    editClicked: function (e) {
        this.taskStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        if (this.taskStatusContext.get('userId') === -1)
            this.copyDefaultStatuses(_.bind(function (newStatus) {
                this.taskStatusContext = newStatus;
                this.editStatus();
            }, this));
        else
            this.editStatus();
    },
    editStatus: function () {
        this.$('.add-task-status').prop('disabled', true);
        this.dataTable.refresh();
        this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
            format: 'hex',
            color: this.taskStatusContext.get('color'),
            autoInputFallback: false
        });
        this.$('.colorpicker-input-box').val(this.taskStatusContext.get('color'));
        this.$('.input-task-status').css('color', this.taskStatusContext.get('color'));
    },
    setBGColor: function (e) {
        if (e.type === 'keyup') {
            if (e.keyCode === 13) {
                $(e.currentTarget).blur()
            }
            let color = this.$('.colorpicker-input-box').val();
            if (color.split('')[0] === '#' && color.trim().length === 7) {
                this.colorPicker.setColor(color);
                this.taskStatusContext.set('color', color.toUpperCase());
                this.$('.input-task-status').css('color', color.toUpperCase());
                PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
            }
        } else {
            let color = this.colorPicker.getColor();
            if (color.split('')[0] === '#' && color.trim().length === 7) {
                this.$('.colorpicker-input-box').val(color);
                this.taskStatusContext.set('color', color);
                this.$('.input-task-status').css('color', color);
                PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
            }
        }
    },
    statusSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            status = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-task-status'),
            color = this.$('.colorpicker-input-box').val(),
            isColorValid = color.split('')[0] === '#' && color.trim().length === 7;

        if (_.size($name) > 0) {
            status.set('name', $name.val())
        }
        let isNameValid = _.size(status.get('name')) > 0;

        status.set('color', color);
        status.set('isDefault', (this.$('.input-default-status').prop('checked')));
        status.set('sortOrder', this.taskStatusContext.get('sortOrder'));

        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), isColorValid, {
            errorText: isColorValid ? "" : "Hex must begin with a # followed by 6 letters and/or numbers!"
        });

        let isDefault = status.get('isDefault'),
            successFn = _.bind(function (isDefault) {
                if (isDefault) {
                    _.each(this.collection.models, _.bind(function (status) {
                        if (status.get('statusId') !== this.taskStatusContext.get('statusId'))
                            status.set('isDefault', false);
                    }, this));
                }
                this.taskStatusContext = null;
                this.render()
            }, this);

        if (isNameValid && isColorValid) {
            let wasNew = this.taskStatusContext.isNew();
            this.taskStatusContext.save(null, {
                success: _.bind(function () {
                    if (wasNew)
                        this.collection.add(this.taskStatusContext);
                    successFn(isDefault);
                }, this)
            });
        }
    },
    cancelEditStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        if (this.taskStatusContext.get('name').length === 0) {
            this.dataTable.removeRow(row);
        }
        this.$('.add-task-status').prop('disabled', false);
        this.taskStatusContext = null;
        this.dataTable.refresh();

    },
    deleteClicked: function (e) {
        this.taskStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();

        if (this.taskStatusContext.get('userId') === -1)
            this.copyDefaultStatuses(_.bind(function (newStatus) {
                this.taskStatusContext = newStatus;
                this.deleteStatus(e);
            }, this));
        else
            this.deleteStatus(e);
    },
    deleteStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Task Status",
            body: "Are you sure you want to delete this status?  All tasks that have this status will be set to the Default status if you continue.",
            onDelete: _.bind(function () {
                this.dataTable.removeRow(row);
                this.dataTable.refresh();

                let wasDefault = this.taskStatusContext.get('isDefault');
                this.taskStatusContext.destroy();
                this.taskStatusContext = null;
                _.each(this.collection.models, _.bind(function (status, index) {
                    status.set('sortOrder', index + 1);
                }, this));

                if (wasDefault && this.collection.models.length > 0)
                    this.collection.models[0].set('isDefault', true);

                this.render();
            }, this)
        });

    },
    copyDefaultStatuses: function (callback) {
        new PJQ.views.modals.YesNo({
            header: "Change Task Statuses?",
            body: 'You are currently using the system default task statuses.  To edit a task status, we will need to create custom task statuses for your company.  This may take a minute, would you like to continue?',
            onYes: _.bind(function () {
                this.collection.copy(_.bind(function () {
                    let newStatus = null;
                    if (this.taskStatusContext != null) {
                        let returnName = this.taskStatusContext.get('name');
                        newStatus = _.find(this.collection.models, function (u) {
                            return u.get('name') === returnName;
                        });
                    }
                    this.dataTable.options.data = this.collection.models
                    this.dataTable.render();
                    callback(newStatus);
                }, this));
            }, this)
        });
    }
});


PJQ.views.schedule.TaskListDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'data-table-header-task-list')
        },
        language: {
            emptyTable: 'No tasks have been created yet',
            zeroRecords: "No tasks were found"
        },
        settings: null,
        onTaskEdit: null,
        onTaskDelete: null,
        paging: false,
        scrollRows: true,
        isShowCriticalPath: false,
        isAdmin: true,
        level: 0,
        order: [3, 'asc'],
        orderCookie: PJQ.constants.cookies.SCHEDULE_TASK_LIST_ORDER,
        scrollY: 'auto',
        scrollCollapse: true
    },
    events: {
        'click .btn-edit-task': 'editTaskClicked',
        'click .btn-delete-task': 'deleteTaskClicked',
        'keyup .datatable-search': 'search',
        'click .task-list-clear-filters': 'clearFilters'
    },
    headerData: function () {
        return {
            statuses: this.model.statuses
        };
    },
    afterDataTableRender: function () {
        let self = this;

        if (typeof this.options.afterTableRendered === 'function') {
            this.options.afterTableRendered();
        }
    },
    beforeDataTableRender: function () {
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        this.options.hasCompleteStatus = false;
        this.options.expandAll = true;
        _.each(this.model.statuses.models, function (model) {
            if (model.get('name').toLowerCase().includes('complete')) {
                this.options.hasCompleteStatus = true;
            }
        }, this);

        this.statusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.task-list-filter'),
            defaultValue: this.options.filter,
            isMultiple: true,
            isIntChoices: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter('status', value);
            }, this)
        });
    },
    getContextMenuOptions: function () {
        return {
            actions: [
                {
                    name: 'Edit',
                    iconClass: 'fal fa-pencil',
                    onClick: _.bind(function (row) {
                        this.editTask(row.data());
                    }, this),
                    isShown: _.bind(function (row) {
                        return true;
                    }, this)
                },
                {
                    name: 'New Dependency',
                    iconClass: 'fal fa-plus',
                    onClick: _.bind(function (row) {
                        let newTask = row.data().newDependencyTask();
                        this.model.tasks.add(newTask);
                        this.editTask(newTask);
                    }, this),
                    isShown: _.bind(function (row) {
                        return false;
                    }, this)
                },
                {
                    name: 'New Successor',
                    iconClass: 'fal fa-plus',
                    onClick: _.bind(function (row) {
                        let newTask = row.data().newSuccessorTask();
                        this.model.tasks.add(newTask);
                        this.editTask(newTask);
                    }, this),
                    isShown: _.bind(function (row) {
                        return false;
                    }, this)
                },
                {
                    name: 'Add to Summary Task',
                    onClick: _.bind(function (row) {
                        let task = row.data();
                        this.addToSummaryTaskClicked(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let task = row.data();
                        if (task) {
                            return !this.options.settings.get('lockSchedule');
                        } else {
                            return false;
                        }
                    }, this)
                },
                {
                    name: 'Remove from Summary Task',
                    onClick: _.bind(function (row) {
                        let task = row.data();
                        this.removeSummaryTask(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let task = row.data();
                        if (task) {
                            return task.get('summaryTaskId') > 0 && !this.options.settings.get('lockSchedule');
                        } else {
                            return false;
                        }
                    }, this)
                },
                {
                    name: 'Delete',
                    iconClass: 'fal fa-trash',
                    isDanger: true,
                    onClick: _.bind(function (row) {
                        this.deleteTask(row.data());
                    }, this),
                    isShown: _.bind(function (row) {
                        return true;
                    }, this)
                }
            ]
        };
    },
    addToSummaryTaskClicked: function (task) {
        new PJQ.views.charts.SummaryTaskModal({
            tasks: this.model.tasks,
            task: task,
            project: this.options.project,
            schedule: this.options.schedule,
            onSave: _.bind(function (task, summaryTaskId, isNewTask = false) {
                if (typeof this.options.onTaskUpdateSummary === 'function') {
                    this.options.onTaskUpdateSummary(task, summaryTaskId, isNewTask);
                }
            }, this)
        });
    },
    // search: function (searchText) {
    //     searchText = this.getSearchText();
    //     //
    //     // this.searchDataTable(this.dataTable, searchText);
    // },
    // searchDataTable: function (dataTable, searchText) {
    //     searchText = searchText.toLowerCase();
    //     let hasVisibleChildren = false,
    //         self = this;
    //
    //     // Filter the collection
    //     let filteredModels = this.model.tasks.filter(function (model) {
    //         // Check each attribute in the model
    //         return _.some(model.attributes, function (value) {
    //             // Ensure the value is a string and perform a case-insensitive comparison
    //             if ((typeof value === 'string' || value instanceof String) && _.size(value) > 0) {
    //                 return value.toLowerCase().includes(searchText);
    //             }
    //             return false;
    //         });
    //     });
    //
    //     // Extract summaryTaskIds from filteredModels
    //     let summaryTaskIds = _.uniq(filteredModels.map(function (model) {
    //         return model.get('summaryTaskId');
    //     }));
    //
    //     // Include models whose id matches one of the summaryTaskIds
    //     this.model.tasks.forEach(function (model) {
    //         if (summaryTaskIds.includes(model.id) && !_.findWhere(filteredModels, {id: model.id})) {
    //             filteredModels.push(model);
    //         }
    //     });
    //
    //     dataTable.rows().every(function () {
    //         let row = this;
    //         let rowData = row.data();
    //         let childTable = row.child.isShown() && $(row.node()).next('tr').find('table').DataTable();
    //
    //
    //         // Check if the current row matches the search text
    //         let rowMatches = _.contains(filteredModels, rowData);
    //
    //
    //         // Recursively search in child DataTable, if present
    //         let childMatches = false;
    //         if (childTable) {
    //             childMatches = self.searchDataTable(childTable, searchText);
    //         }
    //
    //         // Check row visibility
    //         let showRow = rowMatches || childMatches;
    //         row.node().style.display = showRow ? '' : 'none';
    //         // Rows with children have an extra <tr> after the actual row. If it isn't hidden there will be a grey line for every empty child table.
    //         // Hide that row if the row is hidden, or show if not.
    //         if (!$(row.node()).next('tr').hasClass('odd') && !$(row.node()).next('tr').hasClass('even')) {
    //             showRow ? $(row.node()).next('tr').show() : $(row.node()).next('tr').hide();
    //         }
    //
    //         if (showRow) hasVisibleChildren = true;
    //     });
    //
    //     return hasVisibleChildren;
    // },
    removeSummaryTask: function (task) {
        if (typeof this.options.onTaskUpdateSummary === 'function') {
            this.options.onTaskUpdateSummary(task, 0);
        }
    },
    getRowChildData: function (row) {
        let id = row.data().id,
            data = this.model.tasks.get(id);
        if (row) {
            return this.model.tasks.where({summaryTaskId: data.id});
        }
    },
    getRowChildColumns: function (opts) {
        return this.getColumns(opts);
    },
    getChildRowData: function (parentId, id) {
        return this.model.tasks.get(id);
    },
    // getRowChildTable: function (opts) {
    //     return new PJQ.views.schedule.TaskListDataTable(_.extend(opts, {
    //         model: this.model,
    //         onTaskEdit: this.options.onTaskEdit,
    //         onTaskDelete: this.options.onTaskDelete,
    //         onTaskUpdateSummary: this.options.onTaskUpdateSummary,
    //         hasCompleteStatus: this.options.hasCompleteStatus,
    //         scrollRows: false,
    //         hideColumnHeaders: true,
    //         settings: this.options.settings,
    //         level: this.options.level + 1,
    //         summaryTaskId: this.model.tasks.get(opts.parentId).id,
    //         onChildTableRendered: _.bind(function () {
    //             this.search(this.getSearchText);
    //         }, this)
    //     }));
    // },
    getColumns: function (opts) {
        let groupByGroup = function (data) {
            let gr = data.get('groups');
            if (_.size(gr) === 0) {
                return 'None';
            }

            return _.map(gr, function (group) {
                return group.groupName;
            }).join(', ');
        }

        return [
            {
                "columnData": "taskName",
                "data": "attributes.name",
                "title": "Name",
                "width": "20%",
                "render": (data, type, row) => {
                    let padding = (opts?.level ?? 0) * 30,
                        html = '';

                    if (row.get('isSummaryTask')) {
                        html += '<i class="mr-1 fal fa-plus-circle toggle-row ' + (!row.get('isSummaryTask') ? 'invisible' : '') + '" data-type="" data-id="' + row.id + '" style="cursor: pointer"></i>';
                    }

                    html += '<a class="btn-edit-task" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('name') + '</a>';

                    return '<div style="padding-left:' + padding.toString() + 'px;">' + html + '</div>';
                },
            },
            {
                "columnData": "duration",
                "data": "attributes.duration",
                "title": "Duration",
                "width": "80px",
                "render": (data, type, row) => {
                    return `${row.get('duration') ?? ''}`
                }
            },
            {
                "columnData": "start",
                "data": {
                    "_": function (row) {
                        return new Date(row.attributes.start);
                    },
                    "filter": "attributes.start",
                    "display": function (row) {
                        if (row.get('start') == null) {
                            return '';
                        }

                        let offsetClass = '';
                        if (row.get('finish') != null) {
                            let active = PJQ.helpers.dateHelpers.checkDateBetweenDays(row.get('start'), row.get('finish')),
                                overdue = row.get('percentComplete') < 100 && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(row.get('finish'));
                            if (active) {
                                offsetClass = 'text-primary font-weight-medium';
                            } else if (overdue) {
                                offsetClass = 'text-danger font-weight-bold';
                            } else {
                                let offset = PJQ.helpers.dateHelpers.getDateDaysDiff(row.get('finish'), new Date());
                                if (offset < 0) {
                                    offsetClass = 'text-muted';
                                }
                            }
                        }
                        return '<span class="' + offsetClass + '">' + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('start')), PJQ.helpers.dateHelpers.dateFormats.DATE) + '</span>';
                    }
                },
                "group": function (data, groupBy) {
                    switch (groupBy) {
                        case PJQ.constants.schedule.taskList.groupBy.MONTH:
                            return data.get('start') ? PJQ.helpers.dateHelpers.getDateString(data.get('start'), PJQ.helpers.dateHelpers.dateFormats.MONTH_YEAR) : null;
                        case PJQ.constants.schedule.taskList.groupBy.WEEK:
                            let startOfWeek = moment(data.get('start')).startOf('week').toDate(),
                                endOfWeek = moment(data.get('start')).endOf('week').toDate();
                            return data.get('start') != null ? PJQ.helpers.dateHelpers.getDateString(startOfWeek, PJQ.helpers.dateHelpers.dateFormats.DATE) + ' - ' + PJQ.helpers.dateHelpers.getDateString(endOfWeek, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                        case PJQ.constants.schedule.taskList.groupBy.DAY:
                            return data.get('start') != null ? PJQ.helpers.dateHelpers.getDateString(data.get('start'), PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                    }
                    return 'N/A';
                },
                "width": "100px",
                "title": "Start"
            },
            {
                "columnData": "finish",
                "data": {
                    "_": function (row) {
                        return new Date(row.attributes.finish);
                    },
                    "filter": "attributes.finish",
                    "display": function (row) {
                        if (row.get('finish') == null) {
                            return '';
                        }

                        let offsetClass = '';
                        if (row.get('start') != null) {
                            let active = PJQ.helpers.dateHelpers.checkDateBetweenDays(row.get('start'), row.get('finish')),
                                overdue = row.get('percentComplete') < 100 && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(row.get('finish'));
                            if (active) {
                                offsetClass = 'text-primary font-weight-medium';
                            } else if (overdue) {
                                offsetClass = 'text-danger font-weight-bold';
                            } else {
                                let offset = PJQ.helpers.dateHelpers.getDateDaysDiff(row.get('finish'), new Date());
                                if (offset < 0) {
                                    offsetClass = 'text-muted';
                                }
                            }
                        }
                        return '<span class="' + offsetClass + '">' + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('finish')), PJQ.helpers.dateHelpers.dateFormats.DATE) + '</span>';
                    }
                },
                "width": "100px",
                "title": "Finish"
            },
            {
                "attribute": "groups",
                "columnData": function (row) {
                    return row.get('groups');
                },
                "isArrayGroup": true,
                "group": function (data) {
                    return groupByGroup(data);
                },
                "render": function (data, type, row) {
                    if (type === 'sort') {
                        return groupByGroup(row);
                    }

                    if (_.size(row.groups.models) === 0) {
                        return 'None';
                    }

                    return _.map(row.groups.models, function (group) {
                        return group.get('groupName');
                    }).join(', ');
                },
                "width": "200px",
                "title": this.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ?? "Trades"
            },
            {
                "attribute": "assignees",
                "columnData": function (row) {
                    return row.get('assignees');
                },
                "render": function (data, type, row) {
                    if (_.size(row.assignees.models) === 0) {
                        return 'Nobody';
                    }

                    return _.map(row.assignees.models, function (assignee) {
                        let res = assignee.get('contactName');
                        return _.size(res) > 0 ? res : assignee.get('companyName');
                    }).join(', ');
                },
                "width": "150px",
                "title": "Assignees"
            },
            {
                "data": "notes",
                "title": "Notes",
                "render": function (data, type, row) {
                    return row.get('notes');
                }
            },
            {
                "columnData": "percentComplete",
                "data": {
                    "_": function (row) {
                        return row.attributes.percentComplete;
                    },
                    "filter": "attributes.percentComplete",
                    "display": function (row) {
                        let percent = row.get('percentComplete'),
                            progressBg;
                        if (percent < 60) {
                            progressBg = 'bg-danger';
                        } else if (percent >= 60 && percent < 100) {
                            progressBg = 'bg-warning';
                        } else {
                            progressBg = 'bg-success';
                        }
                        return '<div class="progress ht-25p"><div class="progress-bar ' + progressBg + ' text-white fs-16" role="progressbar" style="width:' + percent + '%">' + percent + '%</div></div>';
                    }
                },
                "width": "125px",
                "title": "Progress"
            },
            {
                "columnData": "status",
                "data": {
                    "_": function (row) {
                        return row.status != null ? row.status.get('sortOrder') : 0;
                    },
                    "filter": "attributes.statusId",
                    "display": _.bind(function (row) {
                        if (row.status == null) {
                            return '';
                        }

                        let overdue = row.get('percentComplete') < 100 && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(row.get('finish')),
                            enableOverdueStatus = this.options.settings.get('enableOverdueStatus');
                        if (row.get('finish') != null && this.options.hasCompleteStatus && (row.status == null || row.status.get('name').toLowerCase() !== 'complete') && overdue && enableOverdueStatus) {
                            return '<span class="text-danger font-weight-bold">Overdue</span>';
                        } else {
                            return '<span style="color:' + row.status.get('color') + '">' + row.status.get('name') + '</span>';
                        }
                    }, this)
                },
                "width": "100px",
                "title": "Status"
            },
            {
                "title": '',
                "render": _.bind(function () {
                    let result = '<div class="show-on-row-hover min-wd-80p"><button type="button" class="btn btn-info btn-edit-task mr-1" title="Edit Task"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        result += '<button type="button" class="btn btn-danger btn-delete-task" title="Delete Task"><i class="fal fa-trash-alt"></i></button>';
                    }
                    result += '</div>';
                    return result;
                }, this),
                "orderable": false,
                "searchable": false,
                'resizable': false,
                "width": "100px",
                "className": "text-center",
                "visible": true
            }
        ];
    },
    createdRow: function (row, data) {
    },
    editTaskClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            tr = target.closest('tr'),
            cid = tr.attr('id'),
            task = this.model.tasks.get(cid);

        this.editTask(task);
    },
    deleteTaskClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            tr = target.closest('tr'),
            cid = tr.attr('id'),
            task = this.model.tasks.get(cid);

        this.deleteTask(task);
    },
    onRowDoubleClick: function (row, $el) {
        this.editTask(row.data());
    },
    editTask: function (task) {
        if (typeof this.options.onTaskEdit === 'function') {
            this.options.onTaskEdit(task);
        }
    },
    deleteTask: function (task) {
        if (typeof this.options.onTaskDelete === 'function') {
            this.options.onTaskDelete(task);
        }
    },
    getFilterData: function (view) {
        // let statusFilter = this.getFilter('status'),
        //         filtered = _.filter(this.model.tasks.models, function (task) {
        //             return !task.get('isSummaryTask');
        //         }, this);
        //     if (_.size(statusFilter) > 0) {
        //         filtered = _.filter(filtered, function (task) {
        //             return statusFilter.indexOf(task.status.id) !== -1;
        //         }, this);
        //     }

        let statusFilter = this.getFilter('status'),
            filtered = _.filter(this.model.tasks.models, function (task) {
                let summaryTaskId = task.get('summaryTaskId');
                return this.options.summaryTaskId !== task.id && (this.options.summaryTaskId === summaryTaskId || (this.options.summaryTaskId == null && summaryTaskId == null));
            }, this);

        if (this.dataTable != null) {
            filtered = this.model.tasks.models
        }

        if (_.size(statusFilter) > 0) {
            filtered = _.filter(filtered, function (task) {
                return statusFilter.indexOf(task.status.id) !== -1;
            }, this);
        }

        return filtered;
    },
    clearFilters: function () {
        this.statusFilterPicker.deselectAll();
        this.searchBar.val('');
        this.filterBidders();
    }
});

PJQ.views.schedule.TaskList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-List'),
        onTaskEdit: null,
        onTaskDelete: null,
        isShowCriticalPath: false,
        isAdmin: true
    },
    events: {},
    renderData: function () {
        return {
            model: this.model
        };
    },
    beforeRender: function () {
        if (this.options.settings == null) {
            if (this.options.project != null) {
                this.options.project.fetchScheduleSettings(_.bind(function (settingsRes) {
                    this.settings = settingsRes;
                }, this));
            } else {
                PJQ.app.session.fetchScheduleSettings(_.bind(function (settingsRes) {
                    this.settings = settingsRes;
                }, this));
            }
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.schedule.TaskListDataTable({
            el: this.$('.task-list'),
            model: this.model,
            isShowCriticalPath: this.options.isShowCriticalPath,
            isAdmin: this.options.isAdmin,
            settings: this.settings,
            afterTableRendered: _.bind(function () {
                if (typeof this.options.afterTableRendered === 'function') {
                    this.options.afterTableRendered();
                }
            }, this),
            onTaskEdit: _.bind(function (task) {
                if (typeof this.options.onTaskEdit === 'function') {
                    this.options.onTaskEdit(task);
                }
            }, this),
            onTaskDelete: _.bind(function (task) {
                if (typeof this.options.onTaskDelete === 'function') {
                    this.options.onTaskDelete(task);
                }
            }, this),
            onTaskUpdateSummary: _.bind(function (task, summaryTaskId) {
                if (typeof this.options.onTaskUpdateSummary === 'function') {
                    this.options.onTaskUpdateSummary(task, summaryTaskId);
                }
            }, this),
        });

        if (this.options.project != null) {
            this.options.project.off('scheduleTaskChanged');
            this.options.project.on('scheduleTaskChanged', function (task, isNew, isSummaryUpdate = false, isDelete = false) {
                let $scroll = this.dataTable.$el.find('.dt-scroll-body'),
                    scrollY = $scroll.scrollTop();

                if (isSummaryUpdate) {
                    this.dataTable.render();
                } else if (task.get('summaryTaskId')) {
                    // levels tracks how many child tables we'll need to go through to get to the target child table
                    // Work from the top down to find the child table we want
                    let levels = 0,
                        summaryTaskIds = [],
                        taskTable = null,
                        // findSummaryTask will start at the edited task, and work its way up to find the highest level task
                        findSummaryTask = _.bind(function (t) {
                            levels++;
                            if (t.get('summaryTaskId')) {
                                let summaryTask = this.model.tasks.get(t.get('summaryTaskId'));
                                summaryTaskIds.push(summaryTask.id);
                                // If the summary task also has a summaryTaskId, then keep going up
                                if (summaryTask.get('summaryTaskId')) {
                                    findSummaryTask(summaryTask);
                                }
                            }
                        }, this);

                    // initial call of findSummaryTask
                    findSummaryTask(task);

                    // Once we've found all the relevant tasks then we need to work from the top down to find the child table.
                    let findDataTable = _.bind(function (table) {
                        // find the relevant child table
                        let childTable = _.find(table.options.childDataTables, function (child) {
                            return summaryTaskIds.find((id) => id === child.options.summaryTaskId)
                        }, this);

                        // Reduce the levels. If levels is 0 then we've found the target table, otherwise we need to keep going.
                        levels--;
                        if (levels === 0) {
                            taskTable = childTable;
                        } else {
                            findDataTable(childTable);
                        }
                    }, this);

                    // initial call of findDataTable. Will always start with the highest level table
                    findDataTable(this.dataTable);

                    // Assuming we've found the table successfully, then we can refresh or add a row. If we didn't find the table, then just re-render the whole table.
                    if (taskTable != null) {
                        if (isDelete) {
                            let row = taskTable.getRow(task.cid);
                            if (row) {
                                taskTable.removeRow(row);
                            }
                        } else if (isNew) {
                            taskTable.addRow(task);
                        } else {
                            taskTable.refresh();
                        }
                    } else {
                        this.dataTable.render();
                    }
                } else {
                    if (isDelete) {
                        let row = this.dataTable.getRow(task.cid);
                        if (row) {
                            this.dataTable.removeRow(row);
                        }
                    } else if (isNew) {
                        this.dataTable.addRow(task);
                    } else {
                        this.dataTable.refresh();
                    }
                }
                this.dataTable.$el.find('.dt-scroll-body').scrollTop(scrollY);
            }, this);
        }
    }
});

PJQ.views.schedule.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.schedule.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.schedule.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.schedule.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});

PJQ.views.schedule.EditTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Edit-Template'),
        maxWidth: '90%',
        fitHeight: true,
        onClose: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: function () {
        this.listenTo(this.model, 'fetch', this.render);
        this.model.fetch();
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model.isFetched) {
            // new PJQ.Alert(this.$('.manage-template-alert'), {
            // 	text: "Task start and finish dates are shown as they were originally saved.  When importing these templates on a project, you will be asked to specify a start date.  All task dates will be modified according using the start date provided.",
            // 	isPrepend: true,
            // 	cookie: PJQ.constants.cookies.SCHEDULE_TEMPLATE_DATES_ORIGIN
            // });

            new PJQ.inputs.TextEditorInput({
                el: this.$('.edit-template-name'),
                label: 'Name',
                value: this.model.get('name'),
                onSave: _.bind(function (value) {
                    this.model.patch({
                        name: value
                    });
                }, this)
            });

            new PJQ.views.schedule.ScheduleDashboard({
                el: this.$('.manage-template'),
                model: this.model
            });
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.schedule.SaveAsTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Save-As-Template'),
        maxWidth: 500
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.schedule.Template({
            projectId: this.options.project.id
        });

        this.options.project.fetchScheduleTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-template-name'),
                source: _.map(this.templates.models, function (template) {
                    return template.get('name')
                })
            });
        }
    },
    save: function () {
        let $name = this.$('.input-template-name'),
            name = $name.val();
        if (_.size(name.trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError($name);
            return;
        } else {
            PJQ.helpers.inputHelpers.setInputError($name, true);
        }

        let existingTemplate = this.templates.findWhere({name: name}),
            fnSave = _.bind(function () {
                this.model.set({
                    name: name,
                    copyAssignees: this.$('.input-copy-assignees').prop('checked'),
                    copyDependencies: this.$('.input-copy-dependencies').prop('checked'),
                    copyComments: this.$('.input-copy-comments').prop('checked'),
                    copyAttachments: this.$('.input-copy-attachments').prop('checked')
                });
                this.model.save(null, {
                    success: _.bind(function () {
                        this.removeModal();
                        PJQ.notifications.notify.successNotify({
                            message: 'Schedule Template Created'
                        });
                    }, this)
                });
            }, this);
        if (existingTemplate != null) {
            new PJQ.views.modals.YesNo({
                header: "Overwrite Template",
                body: "A template already exists with this name.  Would you like to overwrite it?",
                onYes: _.bind(function () {
                    this.model.set('templateId', existingTemplate.id);
                    fnSave();
                }, this)
            });
        } else {
            fnSave();
        }
    }
});

PJQ.views.schedule.UploadTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Upload-Template'),
        maxWidth: 500,
        onImport: null,
        weekendWork: true
    },
    events: {
        'change .cb-weekend-work': 'weekendWorkChanged'
    },
    renderData: function () {
        return {
            weekendWork: this.options.weekendWork
        };
    },
    afterRender: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.template-uploader'),
            allowedExtensions: ['mpp', 'mpx', 'mspdi', 'pp'],
            endpoint: this.makeUploadEndpoint(),
            previewImageDimension: 150,
            onDrop: () => {
                this.$('.import-loading').removeClass('hidden');
                this.$('.btn-close').prop('disabled', true);
            },
            onSuccess: () => {
                if (typeof this.options.onImport === 'function') {
                    this.options.onImport();
                }
                this.removeModal();
            }
        });
    },
    makeUploadEndpoint: function () {
        let params = [{
            parameter: 'weekendWork',
            value: this.options.weekendWork
        }];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'upload'
            }
        ], params)
    },
    weekendWorkChanged: function (e) {
        this.options.weekendWork = $(e.currentTarget).prop('checked');
        this.fileUploader.options.endpoint = this.makeUploadEndpoint();
    }
});

PJQ.views.schedule.ImportTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Import-Template'),
        maxWidth: 500,
        onImport: null
    },
    events: {
        'click .btn-import': 'save'
    },
    beforeModalCreated: function () {
        this.options.project.fetchScheduleTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            this.templatePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-template'),
                onChange: _.bind(function (value) {
                    this.selectedTemplate = this.templates.get(value);
                }, this),
                isIntChoices: true,
                noneSelectedText: 'Select Template'
            });

            this.startDate = _.size(this.options.project.get('startDate')) > 0 ? new Date(this.options.project.get('startDate')) : null;
            this.startDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-start-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.startDate
                },
                onChange: _.bind(function (value) {
                    this.startDate = value;
                }, this)
            });
        }
    },
    save: function () {
        let isValid = true;
        if (this.selectedTemplate == null) {
            this.templatePicker.showError();
            isValid = false;
        } else {
            this.templatePicker.hideError();
        }

        if (this.startDate == null) {
            this.startDatePicker.showError();
            isValid = false;
        } else {
            this.startDatePicker.hideError();
        }

        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'import',
                    value: this.selectedTemplate.id
                }
            ], [
                {
                    parameter: 'start',
                    value: PJQ.helpers.dateHelpers.getDateString(new Date(this.startDate), 'yyyy-MM-dd')
                },
                {
                    parameter: 'importAssignees',
                    value: this.$('.input-import-assignees').prop('checked')
                },
                {
                    parameter: 'importDependencies',
                    value: this.$('.input-import-dependencies').prop('checked')
                },
                {
                    parameter: 'importComments',
                    value: this.$('.input-import-comments').prop('checked')
                }, {
                    parameter: 'importAttachments',
                    value: this.$('.input-import-attachments').prop('checked')
                }
            ])
        }).put().done(_.bind(function (response) {
            if (typeof this.options.onImport === 'function') {
                let result = new PJQ.models.schedule.Schedule(response);
                result.isFetched = true;
                this.options.onImport(result);
            }
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Schedule Template Imported'
            });
        }, this));
    }
});